export default {
  title: "StockTag.AI",
  apiKeyPlaceholder: "Enter OpenAI API Key",
  saveApiKey: "Save API Key",
  showApiKey: "Show API Key",
  hideApiKey: "Hide API Key",
  vectorMode: "Vector Image Mode (SVG)",
  dragDropText: "Drag and drop files here or",
  chooseFiles: "Choose Files",
  filesSelected: "file(s) selected",
  generateButton: "Generate Metadata",
  processing: "Processing",
  processingFile: "Processing file",
  of: "of",
  promptsPlaceholder: "Generated prompts will appear here...",
  processedFilesTitle: "Processed Files",
  title_label: "Title",
  keywords_label: "Keywords",
  category_label: "Category",
  downloadCSV: "Download CSV",
  editCSV: "Edit CSV",
  csv_format_123rf: "123RF",
  csv_format_alamy: "Alamy",
  csv_format_depositphotos: "Depositphotos",
  csv_format_dreamstime: "Dreamstime",
  csv_format_freepik: "Freepik",
  csv_format_gettyimages: "Getty Images",
  csv_format_istock: "iStock",
  csv_format_pond5: "Pond5",
  csv_format_motionelements: "Motion Elements",

  error: "Error",
  apiKeyRequired: "Please provide both API key and files",
  previousWorks: "Previous Works",
  newWorkStart: "Start New Work",
  folderNamePlaceholder: "Folder name (optional)",
  folderNameHint: "Note: Date and time will be used automatically if no name is specified",
  selectAll: "Select All",
  deselectAll: "Deselect All",
  deleteSelected: "Delete Selected",
  metadataCount: "metadata",
  settings: 'Settings',
  titleSettings: 'Title Length',
  descriptionSettings: 'Description Length',
  keywordsSettings: 'Keywords Count',
  shortTitle: 'Short',
  mediumTitle: 'Medium',
  longTitle: 'Long',
  shortDescription: 'Short',
  mediumDescription: 'Medium',
  longDescription: 'Long',
  minimalKeywords: 'Minimal',
  standardKeywords: 'Standard',
  mediumKeywords: 'Medium',
  detailedKeywords: 'Detailed',
  words: 'words',
  keywords: 'keywords',
  save: 'Save',
  processedMetadata: 'Processed Metadata',
  clickToOpenInSystemViewer: 'Click to open in system viewer',
  errorOpeningFile: 'Error opening file',
  // Right click menu texts
  copyKeywords: 'Copy Keywords',
  pasteKeywords: 'Paste Keywords',
  removeAllKeywords: 'Remove All Keywords',
  copyAllMetadata: 'Copy All Metadata',
  pasteAllMetadata: 'Paste All Metadata',
  undoPaste: 'Undo Paste',

  // Download with metadata
  csvExport: 'CSV Export',
  imageExport: 'Image Export with Metadata',
  filesReady: 'files ready for download',
  downloading: 'Downloading',
  downloadImagesWithMetadata: 'Download Images with Metadata',
  noFilesToDownload: 'No files to download',
  filesDownloaded: 'files downloaded successfully',
  downloadFailed: 'Download failed',
  incompleteMetadata: 'Some files have incomplete metadata',

  // Art Style Detection
  detectArtStyles: 'Detect Art Styles',
  detectArtStylesDescription: 'Automatically identify and incorporate niche/trending art styles (Y2K, neon chrome, tattoo flash, etc.) into titles, descriptions, and keywords',
  detectArtStylesHelper: 'Examples: Y2K style, Neon chrome, Tattoo flash, Grunge, Psychedelic, Retro cartoon 90s, Whimsical doodle',

  languageLabel: 'Language',
  top_workspace: 'Workspace',
  theme_toggle_aria: 'Switch theme',
  theme_toggle_to_dark: 'Switch to Dark Mode',
  theme_toggle_to_true_dark: 'Switch to True Dark (OLED) Mode',
  theme_toggle_to_neon: 'Switch to Neon Mode',
  theme_toggle_to_light: 'Switch to Light Mode',
  sidebar_navigation: 'Main menu',
  sidebar_expand: 'Expand sidebar',
  sidebar_collapse: 'Collapse sidebar',
  sidebar_menu: 'Menu',
  sidebar_open_panel: 'Open {label} panel',
  sidebar_close_panel: 'Close {label} panel',
  sidebar_group_metadata: 'Metadata Workflow',
  sidebar_group_create: 'Creative Tools',
  sidebar_group_discover: 'Explore',
  sidebar_group_support: 'Account & Support',
  sidebar_group_admin: 'Administration',
  sidebar_more: 'More',
  sidebar_more_company: 'Company',
  sidebar_more_legal: 'Legal',
  sidebar_more_preferences: 'Preferences',
  sidebar_more_legal_display: 'Legal & Display',
  sidebar_locked: 'Locked',
  close_menu: 'Close menu',
  sidebar_social: 'Social',
  cookie_settings: 'Cookie Settings',
  nav_home: 'Home',
  nav_about: 'About',
  nav_editorial_policy: 'Editorial Policy',
  nav_contact: 'Contact',
  nav_metadata: 'Metadata Studio',
  nav_history: 'History',
  nav_blog: 'Blog',
  nav_market_intelligence: 'Market Intelligence',
  nav_free_credits: 'Free Credits',
  nav_image_generator: 'Image Generator',
  nav_prompter: 'Prompter',
  nav_vectorizer: 'Vectorizer',
  nav_pricing: 'Pricing',
  nav_settings: 'Settings',
  vectorizer_title: 'Bulk Image Vectorizer',
  vectorizer_subtitle: 'Convert raster images into clean SVG vectors.',
  prompter_subtitle: 'Build detailed prompts for stock content with creative controls.',
  blog_subtitle: 'Guides and ideas for a stronger stock content workflow.',
  feedback_subtitle: 'Share product ideas and follow their progress.',
  vectorizer_drop_hint: 'Drop JPG, PNG, or WebP images here, or click to browse',
  vectorizer_formats: 'Supports JPG, PNG, WebP, BMP, GIF',
  vectorizer_preset_label: 'Preset:',
  vectorizer_start: 'Start Tracing',
  vectorizer_processing: 'Tracing...',
  vectorizer_download_all: 'Download All',
  vectorizer_complete: 'completed',
  vectorizer_empty_title: 'No images added yet',
  vectorizer_empty_desc: 'Drop images above to start vectorizing',
  nav_bg_remover: 'Background Remover',
  nav_png_to_psd: 'PNG to PSD Converter',
  nav_svg_to_jpg: 'SVG to JPG Converter',
  nav_upscaler: 'AI 4K Upscaler',
  nav_adobe_scripts: 'Adobe Scripts',
  nav_shortcuts: 'Shortcuts',
  nav_feedback: 'Feedback',
  nav_help: 'Help',
  nav_changelog: 'Changelog',
  sidebar_login: 'Sign in',
  sidebar_workspace: 'Workspace',
  sidebar_actions: 'Actions',
  sidebar_export: 'Export',
  sidebar_export_csv: 'Export CSV',
  sidebar_preparing_csv_zip: 'Preparing CSV ZIP',
  sidebar_embed: 'Embed',
  sidebar_zipping: 'Zipping',
  sidebar_new_session: 'New Session',
  sidebar_new: 'New',
  sidebar_tools: 'Tools',
  sidebar_apps: 'Apps',
  sidebar_system: 'System',
  apps_panel_helper: 'Explore upcoming tools. Each app opens on its own page.',
  apps_bg_remover_desc: 'Remove backgrounds in seconds.',
  apps_png_to_psd_desc: 'Convert PNGs into layered PSDs.',
  apps_svg_to_jpg_desc: 'Export clean JPGs from SVGs.',
  apps_upscaler_desc: 'Upscale images for high-res delivery.',
  apps_adobe_scripts_desc: 'Automations for Adobe workflows.',

  upload_byok_limit: 'Daily free BYOK limit reached. Go Unlimited BYOK or buy credits to keep generating.',
  upload_credits_exhausted: 'Credits exhausted. Add your API key to generate up to 100 metadata/day or purchase credits.',
  upload_generating_metadata: 'Generating metadata...',
  upload_drag_drop_fallback: 'Drag and drop files or browse to upload.',
  upload_badge: 'Metadata',
  upload_title: 'Add files to generate stock metadata',
  upload_guest_title: 'From media to marketplace-ready metadata',
  upload_guest_message: 'Explore the workflow with a file. Nothing is uploaded until you sign in.',
  upload_guest_area_label: 'Explore the workflow by choosing or dropping a file',
  upload_guest_choose_file: 'Choose a file',
  upload_guest_preparing_title: 'Preparing your selection',
  upload_guest_preparing_message: 'Checking your files locally before sign-in.',
  upload_guest_ready_title: 'Your selection is ready',
  upload_guest_ready_message: 'Sign in to start metadata generation with this selection.',
  upload_guest_one_file: '1 file selected',
  upload_guest_files_selected: '{count} files selected',
  upload_guest_checking: 'Local check in progress',
  upload_guest_not_uploaded: 'Not uploaded yet',
  upload_guest_preparing_short: 'Preparing',
  upload_guest_ready_short: 'Ready',
  upload_guest_continue: 'Continue to sign in',
  upload_guest_remove: 'Remove selection',
  upload_guest_unsupported: '{count} unsupported file(s) were skipped. Choose JPG, PNG, SVG, EPS, MP4, or MOV.',
  upload_guest_resume_failed: 'Your sign-in succeeded, but the selected files could not be resumed. Please choose them again.',
  upload_browse_files: 'Browse files',
  upload_dropzone_message: 'Drop files anywhere inside this frame or browse to upload.',
  upload_area_label: 'Drop files anywhere in this frame or browse files',
  upload_drop_anywhere_label: 'Whole frame accepts drop',
  upload_frame_hint_title: 'Drop files anywhere inside this frame',
  upload_frame_hint_body: 'Drop files in the workspace, or use Browse files above.',
  upload_mode_group: 'Processing mode',
  upload_mode_standard: 'Standard',
  upload_mode_standard_desc: 'Photos, illustrations, and mixed batches',
  upload_mode_png: 'PNG Mode',
  upload_mode_png_desc: 'Transparent PNG workflows',
  upload_mode_vector: 'Vector Mode',
  upload_mode_vector_desc: 'EPS, SVG, and AI-ready vector batches',
  upload_mode_locked_hint: 'PNG Mode and Vector Mode are locked on Free BYOK. Choose a paid plan to unlock them.',
  upload_mode_mixed_auto: 'Mixed auto',
  upload_setup_summary: 'Current setup',
  upload_settings_title: 'Next generation settings',
  upload_settings_scope: 'Saved automatically and applied to new generations.',
  upload_settings_edit_all: 'Edit all settings',
  upload_settings_content_label: 'Title & description',
  upload_mode_auto_start: 'Auto-start on',
  upload_mode_manual_start: 'Review before generating',
  upload_mode_mixed_hint: 'Mixed upload detected. Files will use image, vector, or video routing automatically.',
  upload_drag_anywhere: 'Drag and drop anywhere',
  upload_formats: 'JPG | PNG | SVG | EPS | MP4 | MOV',
  upload_requirements_summary: 'Supported files and limits',
  upload_video_credit_note: 'Video metadata samples 1 frame per second. Credits are charged at 1 credit per 5 seconds of video.',
  upload_size_note_member: 'Images can be up to {imageLimit}MB each.',
  upload_size_note_guest: 'Files are checked locally first and uploaded only after sign-in. Images can be up to {imageLimit}MB each after sign-in.',
  upload_eps_note: 'EPS10+: An EPS uploaded on its own can be up to {limit}MB. For a larger EPS, add a JPG with the same filename in the same selection.',
  upload_eps_rejected_title: '{count} EPS file(s) could not be added',
  upload_eps_rejected_body: 'An EPS uploaded on its own can be up to {limit}MB. Add a JPG with the same filename in the same selection, or choose a smaller EPS.',
  upload_eps_reselect: 'Choose EPS + JPG',
  upload_eps_error_dismiss: 'Dismiss EPS upload error',
  upload_card_workflow: 'Workflow',
  upload_step_1: 'Drop your files',
  upload_step_2: 'Review titles + keywords',
  upload_step_3: 'Export CSV for marketplaces',
  upload_card_outputs: 'Outputs',
  upload_outputs_body: 'Title, description, keywords, category and platform-ready exports.',
  upload_outputs_footer: 'Adobe, Shutterstock, Vecteezy, Canva and more.',
  upload_warning_byok_title: 'Daily BYOK limit reached',
  upload_warning_credits_title: 'Credits exhausted',
  upload_warning_byok_body: 'Go Unlimited BYOK or buy credits to continue this session after the free BYOK quota.',
  upload_warning_credits_body: 'Add credits to continue without losing this batch, or use your own API key.',
  upload_warning_api_key_cta: 'Enter API key',
  upload_warning_byok_cta: 'See paid options',
  upload_warning_credits_cta: 'Add credits and continue',
  upload_warning_premium_body: 'Upgrade to Unlimited for premium features and unlimited usage.',
  upload_warning_pricing_cta: 'View pricing',
  upload_credit_estimate_title: '{count} files need an estimated {credits} credits',
  upload_credit_estimate_balance: 'Balance: {balance} → {remaining}',
  upload_credit_getty_only_rule: 'Getty/iStock only: 1 AI request and no extra Getty/iStock credit (2 credits with Standard analysis).',
  upload_credit_getty_mixed_rule: 'Getty/iStock + another metadata export: a second AI request adds 1 credit per file (3 credits with Standard analysis).',
  upload_credit_estimate_shortfall: 'Add {shortfall} more credits to finish this batch.',
  upload_credit_estimate_cta: 'Add credits for this batch',
  upload_files_imported_processing: '{count} files imported - processing started',
  upload_files_waiting: '{count} files waiting to process',
  upload_files_waiting_other_tab: '{count} files queued — they will start automatically when processing in the other tab finishes',
  upload_generate_button: 'Generate',
  upload_processing_files: 'Processing {count} files...',
  upload_recent_history_badge: 'Recent exports',
  upload_recent_history_title: 'Latest metadata ZIPs',
  upload_recent_history_body: 'Your latest ZIP exports are available here for quick access.',
  upload_recent_history_more: 'See more',
  upload_recent_history_default: 'Metadata ZIP',
  upload_recent_history_file_count: '{count} files',
  upload_recent_history_loading: 'Loading recent exports...',
  upload_recent_history_pending: 'Download pending…',

  meta_panel_title: 'Metadata Settings',
  meta_optional_label: '{label} (Optional)',
  meta_optional_description: '{description} (Optional)',
  meta_settings_autosaved: 'Saved automatically',
  meta_settings_autosaved_hint: 'You can drag images in now. Saving a template is optional.',
  meta_template_eyebrow: 'Optional templates',
  meta_template_title: 'Optional Metadata Templates',
  meta_template_count: '{count} saved',
  meta_template_count_loading: 'Loading...',
  meta_template_sync_loading: 'Loading account templates...',
  meta_template_sync_saving: 'Saving to your account...',
  meta_template_sync_account: 'Synced to your account',
  meta_template_sync_guest: 'Saved on this device until you sign in',
  meta_template_sync_offline: 'Account sync is waiting for a connection',
  meta_template_sync_error: 'Account templates could not be synchronized',
  meta_template_sync_retry: 'Retry',
  meta_template_device_available: '{count} template(s) found on this device.',
  meta_template_default_name: 'Default',
  meta_template_getty_name: 'Getty/iStock Focused',
  meta_template_unnamed: 'Untitled template',
  meta_template_default_desc: 'Your balanced Stocktag defaults, with Default Metadata CSV selected.',
  meta_template_getty_desc: 'Literal, factual metadata with a dedicated Getty/iStock export workflow.',
  meta_template_multi_market_getty_name: 'Multi-Market + Getty',
  meta_template_multi_market_getty_desc: 'Commercial standard metadata plus a separately generated Getty/iStock version.',
  meta_guided_setup_label: 'Guided Setup',
  meta_workflow_current_settings: 'Current settings',
  meta_active_workflow: 'Metadata workflow',
  meta_workflow_general_stock: 'General Stock',
  meta_workflow_getty_focused: 'Getty/iStock Focused',
  meta_workflow_multi_market_getty: 'Multi-Market + Getty',
  meta_workflow_customized: 'Customized',
  meta_workflow_guided_applied: 'Guided setup applied',
  meta_workflow_defaults_active: 'Stocktag defaults',
  meta_workflow_single_source: 'These are your live, autosaved settings. Guided Setup reconfigures the same settings; it does not create a separate copy.',
  meta_active_workflow_desc: 'Stocktag uses this workflow for new generations.',
  meta_active_workflow_hybrid_desc: 'Standard metadata stays intact while Getty/iStock metadata is generated separately.',
  meta_guided_setup_change: 'Change',
  meta_guided_setup_reconfigure: 'Reconfigure',
  meta_guided_setup_start: 'Guided Setup',
  meta_advanced_settings_label: 'Advanced settings',
  meta_advanced_settings_desc: 'Fine-tune technical controls and reusable templates whenever you need them.',
  meta_template_custom_desc: 'A reusable snapshot of your metadata and export settings.',
  meta_template_current_name: 'Custom settings (saved automatically)',
  meta_template_current_desc: 'These are your live, autosaved settings. Choose a template to replace them, or save this setup as a reusable template.',
  meta_template_pending_apply: '{name} is selected. Click Apply to use it.',
  meta_template_customized: 'Current settings differ from {name}. Your live changes are saved automatically; the reusable template stays unchanged.',
  meta_template_select_label: 'Select a metadata settings template; it is applied immediately',
  meta_template_auto_apply_hint: 'Choose a template to apply it immediately. Live changes keep saving automatically.',
  meta_template_ready_group: 'Ready templates',
  meta_template_yours_group: 'Your templates',
  meta_template_manage_label: 'Manage selected template',
  meta_template_manage_target: 'Reusable template: {name}',
  meta_template_update: 'Update from current',
  meta_template_delete_action: 'Delete',
  meta_template_name_placeholder: 'Template name',
  meta_template_save_current: 'Save as template (optional)',
  meta_template_applied: '{name} applied. New generations will use these settings.',
  meta_template_applied_without_custom_csv: 'The template was applied, but its custom CSV layout is not available on this device.',
  meta_template_name_required: 'Enter a template name first.',
  meta_template_name_duplicate: 'Choose a different template name.',
  meta_template_limit: 'You can save up to {count} templates. Delete one before saving another.',
  meta_template_saved: '{name} saved to your account.',
  meta_template_saved_device: '{name} was saved on this device. Sign in to sync it.',
  meta_template_storage_error: 'Templates could not be saved on this device. Check browser storage access and try again.',
  meta_template_updated: '{name} updated with the current settings.',
  meta_template_updated_device: '{name} was updated on this device.',
  meta_template_server_error: 'The template could not be saved to your account. Check your connection and try again.',
  meta_template_sync_conflict: 'This template changed on another device. The latest account copy has been kept.',
  meta_template_import_title: 'Import templates from this device?',
  meta_template_import_body: '{count} device template(s) will be copied to your account. Existing account templates will be kept.',
  meta_template_import_action: 'Import to account',
  meta_template_imported: '{count} template(s) were synced to your account.',
  meta_template_imported_remaining: '{count} template(s) were synced; {remaining} remain on this device.',
  meta_template_imported_cleanup_error: '{count} template(s) were synced, but the device copies could not be updated.',
  meta_template_delete_title: 'Delete settings template?',
  meta_template_delete_body: '{name} will be removed. Your current settings will not change.',
  meta_template_deleted: '{name} deleted.',
  meta_close_panel: 'Close metadata settings',
  meta_settings_summary: 'Current metadata setup',
  meta_jump_to_section: 'Jump to {section}',
  meta_scope_title: 'Applies to new generations',
  meta_scope_existing_body: 'Settings are saved automatically. Your {count} existing results stay unchanged; regenerate a file to apply the new setup.',
  meta_scope_empty_body: 'Settings are saved automatically and used the next time you generate metadata.',
  meta_section_workflow: 'Workflow',
  meta_auto_start_label: 'Auto-Start Processing',
  meta_auto_start_desc: 'Start generating immediately after drop',
  meta_metadata_language_label: 'Metadata language',
  meta_metadata_language_desc: 'Generate the main title, description, and keywords directly in this language. New generations and regenerations use this setting.',
  meta_metadata_language_getty_desc: 'Getty/iStock-only metadata stays in English for controlled-vocabulary compatibility.',
  meta_section_rights_usage: 'Rights & Usage',
  meta_content_usage_label: 'Content Usage',
  meta_content_usage_commercial: 'Commercial',
  meta_content_usage_commercial_desc: 'Brand-safe metadata for commercial licensing',
  meta_content_usage_editorial: 'Editorial',
  meta_content_usage_editorial_desc: 'Allows factual visible brand and protected-subject terms',
  meta_content_usage_paid_only: 'Commercial/Editorial selection is available with an active Additional Credits balance, a recurring subscription, or Unlimited BYOK.',
  meta_ip_scan_label: 'Dual-Layer Rights Verification • +2 credits',
  meta_ip_scan_desc: 'After metadata generation, two independent GPT-5.4 visual identity checks run and combine their matches. Generic similarities are ignored; named candidates must resolve in a public identity catalog, and characters or logo-free product designs require multiple distinctive visible signals.',
  meta_ip_scan_admin_only_desc: 'This +2-credit GPT-5.4 verification is available only after an administrator enables it for your account.',
  meta_ip_scan_admin_access_note: 'Commercial metadata filtering still runs in the main metadata prompt. The separate dual-layer GPT-5.4 audit requires account access granted from the admin panel and costs +2 credits per file when enabled.',
  meta_ip_scan_editorial_desc: 'Editorial generations do not show commercial brand or copyright warnings.',
  meta_editorial_note: 'Editorial mode writes neutral, factual metadata and may use a clearly visible protected name when relevant. It never guesses people, dates, places, or events. Documentary editorial support varies by marketplace; Creative Fabrica and Design Bundles product fields are not generated in this mode.',
  meta_commercial_note: 'Commercial mode automatically runs the AI-free metadata rights scan for every account and rechecks at export. Generic words such as logo are ignored; named identity matches trigger warnings without blocking export. Preliminary AI observations stay separate from metadata and are not legal conclusions.',
  meta_section_translation: 'Translation',
  meta_auto_translate_label: 'Auto-Translate',
  meta_auto_translate_desc: 'Translate output to target language',
  meta_target_language: 'Target Language',
  meta_lang_tr: 'Turkish',
  meta_lang_en: 'English',
  meta_lang_de: 'German',
  meta_lang_fr: 'French',
  meta_lang_es: 'Spanish',
  meta_lang_it: 'Italian',
  meta_lang_pt: 'Portuguese',
  meta_lang_ru: 'Russian',
  meta_lang_ja: 'Japanese',
  meta_lang_zh: 'Chinese',
  meta_lang_ar: 'Arabic',
  meta_section_title: 'Title',
  meta_label_length: 'Length',
  meta_length_mode_label: 'Length mode',
  meta_length_mode_smart: 'Smart',
  meta_length_mode_custom: 'Custom',
  meta_title_smart_length_desc: 'AI chooses the natural title length from the content while preserving commercially useful detail.',
  meta_description_smart_length_desc: 'AI chooses the natural description length and adds useful context beyond the title.',
  meta_title_option_short: '10-20 words',
  meta_title_option_medium: '12-26 words',
  meta_title_option_long: '20-35 words',
  meta_option_custom: 'Custom',
  meta_range_words: '{min}-{max} words',
  meta_range_free_edit: 'Drag or type values freely.',
  meta_range_presets: 'Quick presets',
  meta_range_min: 'Min',
  meta_range_max: 'Max',
  meta_range_min_value: 'Minimum word count',
  meta_range_max_value: 'Maximum word count',
  meta_capitalize_words: 'Capitalize Words',
  meta_prefix_label: 'Prefix',
  meta_prefix_desc: 'Add text before title',
  meta_prefix_placeholder: 'Enter prefix text...',
  meta_postfix_label: 'Postfix',
  meta_postfix_desc: 'Add text after title',
  meta_postfix_placeholder: 'Enter postfix text...',
  meta_section_description: 'Description',
  meta_desc_option_short: '10-25 words',
  meta_desc_option_medium: '15-30 words',
  meta_desc_option_long: '20-35 words',
  meta_section_keywords: 'Keywords',
  meta_keywords_count: 'Count: {count}',
  meta_keywords_count_mode_label: 'Keyword amount',
  meta_keywords_count_mode_smart: 'Smart',
  meta_keywords_count_mode_fixed: 'Fixed count',
  meta_keywords_smart_desc: 'StockTag performs a complete coverage and omission audit, adds every strong and distinct search term supported by the asset, and stops only when nothing useful remains without adding filler.',
  meta_keywords_japanese_quality_note: 'For Japanese generation, the selected count is a maximum: only the strongest, directly relevant keywords are added, and the list is not padded with unnecessary terms.',
  meta_keyword_type_label: 'Keyword Type',
  meta_keyword_type_single_label: 'Single-Word',
  meta_keyword_type_single_desc: 'sunset, mountain',
  meta_keyword_type_double_label: 'Double-Word',
  meta_keyword_type_double_desc: 'golden sunset',
  meta_keyword_type_mixed_label: 'Mixed',
  meta_keyword_type_mixed_desc: 'Combination',
  meta_no_special_chars: 'No special chars',
  meta_custom_keywords_label: 'Custom Keywords',
  meta_custom_keywords_desc: 'Add predefined keywords to all files',
  meta_custom_keywords_placeholder: 'Enter keywords separated by commas...',
  meta_section_customization: 'Customization',
  meta_custom_instructions_label: 'Custom Instructions',
  meta_custom_instructions_placeholder: 'Add custom AI instructions...',
  meta_human_model_ethnicity_label: 'Human Model Ethnicity (Optional)',
  meta_human_model_ethnicity_none: 'Do not specify',
  meta_human_model_ethnicity_desc: 'When selected, the model uses this user-provided detail only if a person is visible. It does not infer nationality or religion.',
  meta_human_model_ethnicity_caucasian: 'Caucasian / White',
  meta_human_model_ethnicity_black: 'Black / African descent',
  meta_human_model_ethnicity_east_asian: 'East Asian',
  meta_human_model_ethnicity_south_asian: 'South Asian',
  meta_human_model_ethnicity_southeast_asian: 'Southeast Asian',
  meta_human_model_ethnicity_middle_eastern_north_african: 'Middle Eastern / North African',
  meta_human_model_ethnicity_latino_hispanic: 'Latino / Hispanic',
  meta_human_model_ethnicity_indigenous: 'Indigenous',
  meta_human_model_ethnicity_mixed_multiracial: 'Mixed / Multiracial',
  meta_prohibited_words_label: 'Prohibited Words',
  meta_prohibited_words_desc: 'Words to exclude from output',
  meta_prohibited_words_placeholder: 'Enter words to exclude, separated by commas...',
  meta_section_image_mode: 'Image Mode',
  meta_png_mode_label: 'PNG Mode',
  meta_png_mode_hint: 'Optimizes metadata for PNG/bitmap images',
  meta_vector_mode_label: 'Vector Mode',
  meta_vector_mode_hint: 'Optimizes metadata for vector/illustration content',
  meta_section_eps_jpg: 'EPS & JPG',
  meta_eps_generate_label: 'Generate JPG for EPS (EPS10+)',
  meta_eps_generate_desc: 'Create JPG previews for EPS files',
  meta_eps_generate_hint: 'EPS10+ only. If you upload EPS + JPG with the same name, metadata is embedded into both. If only EPS is uploaded and this is enabled, a JPG is generated and metadata is embedded into both.',
  meta_section_ai_features: 'AI Features',
  meta_filename_context_label: 'Use filename as AI context',
  meta_filename_context_desc: 'Send descriptive filenames as a supporting hint when AI writes titles and keywords',
  meta_filename_context_hint: 'The filename is used only as context. Visible content remains the source of truth.',
  meta_prefix_postfix_label: 'Prefix & Postfix',
  meta_locked_title: 'Upgrade required',
  meta_locked_body: 'Available on Unlimited BYOK or credit plans.',
  meta_locked_prepaid_title: 'Top up to unlock',
  meta_locked_prepaid_hint: 'Add credits to reactivate this setting, or compare subscription plans.',
  meta_deep_analysis_label: 'Deep Analysis (Beta)',
  meta_deep_analysis_label_credits: 'Deep Analysis (Beta) • 2x credits',
  meta_deep_analysis_effort_label: 'Analysis level',
  meta_deep_analysis_effort_none: 'Fast Analysis',
  meta_deep_analysis_effort_medium: 'Standard Analysis',
  meta_deep_analysis_effort_high: 'Deep Analysis',
  meta_analysis_level_credit: '{count} credits',
  meta_analysis_level_recommended: 'Recommended',
  meta_analysis_level_fast_hint: 'Professional metadata, fast results',
  meta_analysis_level_standard_hint: 'Stronger context and keyword optimization',
  meta_analysis_level_deep_hint: 'Maximum analysis depth for complex content',
  meta_deep_analysis_effort_decrease: 'Decrease Deep Analysis level',
  meta_deep_analysis_effort_increase: 'Increase Deep Analysis level',
  deep_progress_title: 'Metadata analysis',
  deep_progress_effort_low: 'Fast Analysis',
  deep_progress_effort_medium: 'Standard Analysis',
  deep_progress_effort_high: 'Deep Analysis',
  deep_progress_elapsed: '{time} elapsed',
  deep_progress_step_prepare: 'Preparing file',
  deep_progress_step_analyze: 'Analyzing with AI',
  deep_progress_step_validate: 'Validating output',
  deep_progress_step_save: 'Saving metadata',
  deep_progress_waiting: 'Waiting for the AI response…',
  deep_progress_high_reassurance: 'Deep Analysis checks complex scenes more thoroughly and may take longer. The request is still running normally.',
  deep_progress_pending_count: '{count} files waiting',
  deep_progress_lower_remaining: 'Use Standard for remaining files',
  meta_section_byok: 'BYOK API Keys',
  meta_byok_helper: 'Manage your API keys in User Profile for BYOK usage. Free BYOK includes 100/day; Unlimited BYOK has no limits.',
  meta_byok_button: 'Open API Key Settings',
  meta_byok_no_keys_warning: 'No API keys detected. Add at least one key to use BYOK features.',
  meta_search_clear: 'Clear search',
  meta_search_results: '{count} sections shown',
  meta_progressive_autosave: 'Changes are saved automatically',
  meta_progressive_basic: 'Basics',
  meta_progressive_content: 'Content',
  meta_progressive_advanced: 'AI & Advanced',
  meta_progressive_export: 'Export',
  meta_progressive_search_matches: '{count} settings found',
  meta_progressive_summary_language: 'Metadata',
  meta_progressive_summary_usage: 'Content type',
  meta_progressive_off: 'Off',
  meta_progressive_summary_formats: '{count} active',
  meta_progressive_keyword_max: 'Up to {count}',
  meta_progressive_translation_to: 'Translation → {language}',
  meta_progressive_title_range: 'Title {min}–{max} words',
  meta_progressive_title_smart: 'Title Smart',
  meta_progressive_advanced_active: '{count} advanced settings active',
  meta_progressive_advanced_default: 'Using standard defaults',
  meta_progressive_template_save: 'Save as template',
  meta_progressive_export_active: 'Active',
  meta_progressive_export_inactive: 'Not active',
  meta_progressive_export_remove: 'Remove {name}',
  meta_progressive_export_add: 'Add',
  meta_progressive_export_add_named: 'Add {name}',
  meta_progressive_custom_csv_select: 'Select Custom CSV preset',
  meta_progressive_export_active_tab: 'Active ({count})',
  meta_progressive_export_all_tab: 'All Platforms',
  meta_progressive_platform_add: 'Add platform',
  meta_progressive_platform_choose: 'Choose a platform',
  meta_progressive_platform_all_added: 'All available platforms are active.',
  meta_progressive_export_empty_hint: 'Add only the platforms you use.',
  meta_overview_workflow_auto: 'Auto-start on',
  meta_overview_workflow_manual: 'Manual review',
  meta_overview_metadata_language: 'Metadata: {language}',
  meta_overview_editorial: 'Editorial content',
  meta_overview_commercial_scan: 'Commercial • rights scan on',
  meta_overview_commercial: 'Commercial content',
  meta_overview_translation_off: 'Translation off',
  meta_overview_translation_on: 'Translation: {language}',
  meta_overview_exports: '{count} exports active',
  meta_section_export_formats: 'Export Formats',
  meta_export_active_count: '{count} formats active',
  meta_export_summary_none: 'No export formats selected yet.',
  meta_export_quick_actions: 'Quick export presets',
  meta_export_preset_core: 'Core',
  meta_export_preset_all: 'All',
  meta_export_preset_clear: 'Clear',
  meta_export_cat_general: 'General',
  meta_csv_default_metadata: 'Default Metadata',
  meta_csv_cf_label: 'CF (40 chars)',
  meta_csv_db_label: 'DB (60 chars)',
  meta_csv_adobe_stock: 'Adobe Stock',
  meta_csv_shutterstock: 'Shutterstock',
  meta_csv_canva: 'Canva',
  meta_csv_vecteezy: 'Vecteezy',
  meta_csv_custom: 'Custom CSV',
  meta_csv_summary_custom: 'Custom preset',
  meta_csv_summary_default: 'Default preset',
  meta_csv_summary_columns: '{count} columns',
  meta_csv_status_custom_short: 'Custom',
  meta_csv_status_default_short: 'Default',
  meta_csv_preset_missing: 'No preset configured yet.',
  meta_csv_license_free: 'Free',
  meta_csv_license_pro: 'Pro',
  meta_vecteezy_license_title: 'Vecteezy License',
  meta_custom_csv_editor_title: 'Custom CSV Builder',
  meta_custom_csv_editing: 'Editing: {name}',
  meta_custom_csv_unnamed: 'Untitled template',
  meta_custom_csv_new: 'Create a new saved template',
  meta_custom_csv_status_ready: 'Ready',
  meta_custom_csv_status_draft: 'Draft',
  meta_custom_csv_editor_desc: 'Define your own CSV columns, name the format, and keep it saved in Metadata Settings for later exports.',
  meta_custom_csv_actions: 'Custom CSV actions',
  meta_custom_csv_new_btn: 'New',
  meta_custom_csv_update_btn: 'Update',
  meta_custom_csv_save_btn: 'Save',
  meta_custom_csv_delete_btn: 'Delete',
  meta_custom_csv_reset_btn: 'Reset',
  meta_custom_csv_saved_templates: 'Saved Templates',
  meta_custom_csv_unsaved_draft: 'Unsaved Draft',
  meta_custom_csv_name: 'Template Name',
  meta_custom_csv_name_placeholder: 'Example: Agency Upload Format',
  meta_custom_csv_filename: 'ZIP File Name',
  meta_custom_csv_filename_placeholder: 'agency_upload',
  meta_custom_csv_delimiter: 'Delimiter',
  meta_custom_csv_columns: 'Columns',
  meta_custom_csv_columns_hint: 'Use one line per column: Header=fieldKey or Header=literal:value. Lines starting with # are ignored.',
  meta_custom_csv_ready_summary: '{count} columns ready. Use the field list below while mapping.',
  meta_custom_csv_name_required: 'Template name is required.',
  meta_custom_csv_columns_required: 'Add at least one custom CSV column.',
  meta_custom_csv_delete_confirm: 'Delete this custom CSV template?',
  meta_custom_csv_enable_requires_valid: 'Select or save a valid custom CSV template first.',
  meta_custom_csv_enable_requires_save: 'Save a custom CSV template first.',
  meta_custom_csv_modal_title: 'Custom CSV Builder',
  meta_custom_csv_modal_desc: 'Build and save reusable CSV presets as a proper table layout.',
  meta_custom_csv_active_template: 'Active: {name}',
  meta_custom_csv_no_saved: 'No saved custom preset yet.',
  meta_custom_csv_no_saved_short: 'No preset yet',
  meta_custom_csv_edit_btn: 'Edit Preset',
  meta_custom_csv_make_btn: 'Build Custom CSV',
  meta_custom_csv_make_btn_short: 'Create',
  meta_csv_reset_default_short: 'Reset',
  meta_site_csv_modal_title: '{name} CSV Preset',
  meta_site_csv_modal_desc: 'Adjust this site CSV preset and keep the override saved for future exports.',
  meta_site_csv_name: 'Preset Name',
  meta_site_csv_reset_confirm: 'Reset this site CSV preset back to default?',
  meta_csv_builder_table: 'CSV Table Builder',
  meta_csv_builder_column: 'Column',
  meta_csv_builder_add_column: 'Add Column',
  meta_csv_builder_header: 'Header',
  meta_csv_builder_source: 'Source',
  meta_csv_builder_value: 'Field / Literal',
  meta_csv_builder_preview: 'Preview',
  meta_csv_builder_actions: 'Actions',
  meta_csv_builder_header_placeholder: 'Column header',
  meta_csv_builder_literal_placeholder: 'Literal value',
  meta_csv_builder_move_up: 'Move up',
  meta_csv_builder_move_down: 'Move down',
  meta_csv_builder_empty_title: 'No columns yet',
  meta_csv_builder_empty_body: 'Add columns from the field catalog or create one manually.',
  meta_csv_preview_title: 'Preview Row',
  meta_csv_preview_live: 'Live preview from the first exportable file.',
  meta_csv_preview_mock: 'Preview is using fallback sample data until files are ready.',
  meta_csv_field_search: 'Search fields...',
  meta_csv_field_empty_title: 'No matching fields',
  meta_csv_field_empty_body: 'Try a broader field search term.',
  meta_csv_modal_footer_ready: 'Preset is ready to save.',
  meta_csv_cancel: 'Cancel',
  meta_csv_saving: 'Saving...',
  meta_csv_save_error: 'The preset could not be saved. Try again.',
  meta_csv_action_error: 'The action could not be completed. Try again.',
  meta_csv_unsaved_title: 'Discard unsaved changes?',
  meta_csv_unsaved_close_desc: 'Your changes to this CSV preset will be lost.',
  meta_csv_unsaved_replace_desc: 'Switching templates will replace your unsaved changes.',
  meta_csv_discard_changes: 'Discard Changes',
  meta_csv_switch_template: 'Discard and Switch',
  meta_csv_keep_editing: 'Keep Editing',
  meta_csv_delete_title: 'Delete CSV template?',
  meta_csv_reset_title: 'Reset CSV preset?',
  meta_csv_edit_site_preset: 'Edit {name} preset',
  meta_csv_reset_default: 'Reset to Default',
  meta_csv_save_site_preset: 'Save Preset',
  meta_csv_edit_btn: 'Edit',

  top_tip_prohibited_words: 'Tip: Use Prohibited Words to remove unwanted terms from title/keywords before export.',
  top_tip_prefix_postfix: 'Tip: Prefix/Postfix can standardize your titles across marketplaces.',
  top_tip_export_formats: 'Tip: Enable the formats you need in Export Formats to generate platform-ready CSVs.',
  top_tip_edit_keywords: 'Tip: You can edit keywords in the list view, then export CSV when ready.',
  top_tip_drag_drop: 'Tip: Drag & drop files to start. If Auto-Start is off, click Generate to begin.',
  top_billing_monthly: 'Monthly',
  top_billing_yearly: 'Yearly',
  top_billing_one_time: 'One-time',
  top_price_per_month: '{price}/mo',
  top_price_per_year: '{price}/yr',
  top_price_one_time: '{price} one-time',
  top_credits_unlimited: 'Unlimited usage',
  top_credits_per_month: '{count} credits/mo',
  top_credits_once: '{count} credits once',
  top_billed_yearly: 'Billed {price}/year',
  top_save_amount: 'Save {amount}',
  top_discount_label: '{percent}% OFF',
  top_all_plans: 'All plans',
  top_see_pricing: 'See pricing',
  top_unlimited_badge: 'Unlimited',
  top_processing: 'Processing...',
  top_eta_minutes: '~{minutes}m {seconds}s left',
  top_eta_seconds: '~{seconds}s left',
  top_completed_with_duration: 'Completed • {duration}',
  top_plans_pricing: 'Plans & Pricing',
  top_view_pricing: 'View Pricing',
  top_credit_options: 'Credit options',
  top_view_credit_options: 'View credit options',
  top_credits_empty_title: 'Credits Empty!',
  top_unlimited_byok: 'Unlimited BYOK',
  top_credits_empty_message: 'Go {product} for just {price} (billed yearly) and remove limits.',
  top_go_unlimited: 'Go Unlimited',
  top_dismiss: 'Dismiss',
  top_tour: 'Product tour',
  top_context_mode: 'Mode: {mode}',
  top_context_mode_standard: 'Standard',
  top_context_mode_png: 'PNG',
  top_context_mode_vector: 'Vector',
  top_context_files: 'files',
  top_context_progress: '{processed}/{total} files',
  top_context_ready: '{count} ready',
  top_context_unsaved: '{count} unsaved',
  top_zoom_out: 'Zoom Out',
  top_zoom_in: 'Zoom In',
  top_zoom_reset: 'Reset Zoom',
  top_notifications: 'Notifications',

  history_load_error: 'Failed to load history',
  history_draft_no_metadata: 'No metadata has been processed for this draft yet.',
  history_draft_download_failed: 'Failed to download draft: {message}',
  history_delete_confirm_single: 'Are you sure you want to delete this export?',
  history_delete_confirm_bulk: 'Are you sure you want to delete {count} export(s)?',
  history_title: 'History',
  history_search_placeholder: 'Search by file name or platform...',
  history_search_clear: 'Clear search',
  history_action_cancel: 'Cancel',
  history_action_select: 'Select',
  history_action_select_all: 'Select All',
  history_action_deselect_all: 'Deselect All',
  history_action_delete_selected: 'Delete ({count})',
  history_refresh: 'Refresh',
  history_retention_notice: 'ZIP exports are stored for 30 days',
  history_loading: 'Loading history...',
  history_retry: 'Retry',
  history_empty_matching: 'No matching exports',
  history_empty_none: 'No saved exports yet',
  history_empty_hint: 'Completed CSV ZIPs will appear here',
  history_draft_title: 'Last work ({processed}/{total} files)',
  history_files_count: '{count} files',
  history_draft_autosaving: 'Auto-saving in background...',
  history_draft_recovered: 'Recovered Auto-save Session',
  history_draft_download_success: 'Recovery draft downloaded successfully.',
  history_days_left: '{count} days left',
  history_expiring_soon: 'Expiring soon',
  history_panel_close: 'Close history panel',
  history_overview_total: '{count} total',
  history_overview_shown: '{count} shown',
  history_overview_drafts: '{count} drafts',
  history_overview_last_work: '1 last work',
  history_overview_selected: '{count} selected',
  history_last_work_title: 'Last work ({processed}/{total} files)',
  history_last_work_processing: 'Processing and auto-saving...',
  history_last_work_preparing: 'Preparing CSV ZIP...',
  history_last_work_ready: 'CSV ZIP ready',
  history_last_work_paused: 'Last work saved',
  history_last_work_download: 'Prepare and download CSV ZIP',
  history_last_work_no_metadata: 'No metadata has been saved for this work yet.',
  history_last_work_download_success: 'Last work saved and downloaded.',
  history_last_work_download_failed: 'Failed to download last work: {message}',
  history_formats_label: 'Export formats',
  history_download: 'Download',
  history_download_partial: 'Download Partial Results',
  history_delete: 'Delete',

  detail_panel_title: 'Metadata Editing',
  detail_close: 'Close',
  detail_empty_select_file: 'Select a file from the left to edit',
  detail_size_label: 'Size:',
  detail_unknown: 'Unknown',
  detail_type_label: 'Type:',
  detail_title_label: 'Title',
  detail_translating: 'Translating...',
  detail_copy_title: 'Copy title',
  detail_title_placeholder: 'Image title...',
  detail_syncing: 'Syncing...',
  detail_translate_title_placeholder: 'Translate title ({lang})... Enter to sync.',
  detail_description_label: 'Description',
  detail_copy_description: 'Copy description',
  detail_description_placeholder: 'Image description...',
  detail_translate_description_placeholder: 'Translate description ({lang})... Enter to sync.',
  detail_keywords_label: 'Keywords',
  detail_copy_keywords: 'Copy all keywords',
  detail_remove_keyword: 'Remove',
  detail_remove_keyword_named: 'Remove {keyword}',
  detail_translation_field_label: '{field} translation',
  detail_add_keywords: 'Add keywords...',
  detail_panel_sections: 'Metadata sections',
  detail_nav_qa: 'Check',
  detail_nav_intelligence: 'Insights',
  detail_nav_title: 'Title',
  detail_nav_description: 'Description',
  detail_nav_keywords: 'Keywords',
  detail_nav_categories: 'Categories',
  detail_as_category_label: 'Adobe Stock category',
  detail_as_category_placeholder: 'Select an Adobe Stock category',
  detail_ai_suggestion: 'AI suggestion: {value}',
  detail_ss_category_label: 'Shutterstock category',
  detail_ss_category_placeholder: 'Select a Shutterstock category',
  detail_getty_esp_fields: 'Verified ESP fields',
  detail_getty_esp_fields_note: 'Stocktag only suggests a date or country when the asset contains strong evidence. Leave uncertain values blank and verify suggested or manually entered values in authenticated ESP.',
  detail_getty_country: 'Country (required for ESP)',
  detail_getty_country_placeholder: 'Search country name or ISO code',
  detail_getty_country_clear: 'Clear country',
  detail_getty_country_toggle: 'Show country options',
  detail_getty_country_no_results: 'No matching country. Try its English name or ISO code.',
  detail_getty_country_standard_value: 'Standard country value',
  detail_getty_country_choose_standard: 'Choose a suggestion to use a standard English country value.',
  detail_getty_country_help: 'Leave blank when the country cannot be verified.',
  detail_getty_created_date: 'Created date (required for ESP)',
  detail_getty_date_actions: 'Created date shortcuts',
  detail_getty_date_today: 'Today',
  detail_getty_date_clear: 'Clear',
  detail_getty_date_invalid: 'The saved date is invalid. Pick an exact date or clear it.',
  detail_getty_date_help: 'Date only · saved as MM/DD/YYYY · time is not required by the ESP CSV profile. Leave blank if unverified.',
  detail_reset_draft: 'Revert to saved',
  detail_reset_draft_title: 'Discard unsaved edits and restore the last saved version.',

  low_credit_title: 'Running low on credits',
  low_credit_message: 'Only {count} {unit} remaining. Go {product} to remove limits.',
  low_credit_unit_single: 'credit',
  low_credit_unit_plural: 'credits',
  low_credit_cta: 'Go Unlimited BYOK',
  low_credit_zero_title: 'Credits exhausted',
  low_credit_zero_message: 'Credits ran out. Buy more to continue this session without losing your queue.',
  low_credit_zero_ready_message: 'Credits ran out. Buy more to continue, or export the {count} ready file(s) from this session.',
  low_credit_zero_cta: 'Buy credits to continue',
  low_credit_limit_title: 'Free BYOK limit reached',
  low_credit_limit_message: 'Free BYOK covered today\'s quota. {waiting} file(s) are waiting. Go Unlimited BYOK or buy credits to continue this session.',
  low_credit_limit_ready_message: 'Free BYOK covered today\'s quota. {waiting} file(s) are waiting. Go Unlimited BYOK or buy credits to continue, or export the {ready} ready file(s) now.',
  low_credit_limit_cta: 'See paid options',
  low_credit_resources_title: 'API key or credits required',
  low_credit_resources_message: '{waiting} file(s) are paused because this session needs an API key or credits. Add one of them to continue.',
  low_credit_resources_ready_message: '{waiting} file(s) are paused because this session needs an API key or credits. Add one of them to continue, or export the {ready} ready file(s) now.',
  low_credit_resources_cta: 'Open paid options',
  low_credit_credit_first_message: 'You have {count} {unit} remaining. Choose a managed-credit plan for recurring use or top up when needed. BYOK remains a separate option if you prefer to manage your own API key.',
  low_credit_credit_first_cta: 'View credit options',
  low_credit_zero_credit_first_message: 'Choose a managed-credit plan or top up to continue this session without losing your queue. BYOK is a separate option for users who want to manage their own API key.',
  low_credit_zero_credit_first_ready_message: 'Choose a managed-credit plan or top up to continue, or export the {count} ready file(s) from this session. BYOK remains available separately.',
  low_credit_zero_credit_first_cta: 'Choose credits to continue',
  low_credit_limit_credit_first_message: 'Your Free BYOK daily allowance is used. Add managed credits for the {waiting} waiting file(s), or choose Unlimited BYOK if you prefer to keep managing your own API key.',
  low_credit_limit_credit_first_ready_message: 'Your Free BYOK daily allowance is used. Add managed credits for the {waiting} waiting file(s), or export the {ready} ready file(s) now. Unlimited BYOK remains available separately.',
  low_credit_limit_credit_first_cta: 'View credit options',
  low_credit_resources_credit_first_message: '{waiting} file(s) are paused. Add managed credits to continue without API key setup, or add your own API key separately.',
  low_credit_resources_credit_first_ready_message: '{waiting} file(s) are paused. Add managed credits to continue, or export the {ready} ready file(s) now. You can also add your own API key separately.',
  low_credit_resources_credit_first_cta: 'View credit options',
  low_credit_dismiss: 'Dismiss',
  paused_session_byok_title: 'Free BYOK quota reached for this session',
  paused_session_byok_with_credits_body: 'Your daily Free BYOK quota is used. {waiting} file(s) are paused. You can continue this open session with your remaining {credits} credits, or open plans to buy more credits or switch to Unlimited BYOK.',
  paused_session_byok_body: 'Your daily Free BYOK quota is used. {waiting} file(s) are paused. Buy credits or switch to Unlimited BYOK to continue this open session.',
  paused_session_export_hint: '{count} ready file(s) can already be exported. If you do not want to continue, close this window and keep the session paused.',
  paused_session_stay_paused: 'Stay paused',
  paused_session_open_pricing: 'Open plans and credits',
  paused_session_continue_with_credits: 'Continue with {credits} credits',
  processing_waiting_for_credits: 'Waiting for credits',
  processing_waiting_for_credits_desc: 'Buy credits to continue this session without losing ready files.',
  processing_waiting_for_credits_banner: 'Credits exhausted. {count} file(s) are waiting for additional credits.',
  processing_waiting_for_credits_partial: 'Processing {processed} file(s) now. {waiting} more file(s) are waiting for additional credits.',
  processing_waiting_for_limit: 'Waiting for paid continuation',
  processing_waiting_for_limit_desc: 'Upgrade to Unlimited BYOK or buy credits to continue this session without losing ready files.',
  processing_waiting_for_limit_banner: 'Free BYOK limit reached. {count} file(s) are waiting for Unlimited BYOK or credits.',
  processing_waiting_for_limit_partial: 'Free BYOK will process {processed} file(s) now. {waiting} more file(s) are waiting for Unlimited BYOK or credits.',
  processing_paused: 'Paused',
  processing_waiting_for_resources: 'Paused (Action required)',
  processing_waiting_for_resources_desc: 'Add an API key or credits to continue this session without losing ready files.',
  processing_waiting_for_resources_banner: '{count} file(s) are waiting for an API key or credits. This session is paused until you add one.',
  processing_resume_after_topup: 'Credits added. Resuming {count} waiting file(s).',
  processing_resume_after_payment: 'Paid access enabled. Resuming {count} waiting file(s).',
  processing_resume_after_resources: 'Resources updated. Resuming {count} waiting file(s).',
  credits_purchase_success: 'Your pay-as-you-go credits are ready. You now have {credits} credits available.',
  guest_prompt_title: 'Ready to {context}?',
  guest_prompt_body: 'Sign in to unlock real processing, exports, and history. You can keep exploring the app without signing in.',
  guest_prompt_keep_exploring: 'Keep Exploring',
  guest_prompt_sign_in: 'Sign In',
  guest_prompt_context_continue: 'continue',
  guest_prompt_context_regenerate_metadata: 'regenerate metadata',
  guest_prompt_context_upload_files: 'upload files',
  guest_prompt_context_ai_refinement: 'use AI refinement',
  guest_prompt_context_start_processing: 'start processing',
  guest_prompt_context_export_csv: 'export CSV',
  guest_prompt_context_download_images_with_metadata: 'download images with metadata',
  guest_sample_title: 'Sample CSV preview',
  guest_sample_body_live: 'Preview and download now reflect your saved UI edits (metadata + Adobe + Shutterstock).',
  guest_sample_body_default: 'Download includes the original metadata, Adobe Stock, and Shutterstock CSV files from the bundled sample folder.',
  guest_sample_close: 'Close',
  guest_sample_copy_csv: 'Copy CSV',
  guest_sample_download_zip: 'Download sample CSVs',
  guest_sample_sign_in: 'Sign In for real exports',
  login_promo_referral_title: 'You were invited to Stocktag',
  login_promo_referral_body: 'Create your free account to unlock metadata tools in minutes. After signup, your inviter receives referral credits automatically.',
  login_promo_upload_title: 'Sign in to generate metadata',
  login_promo_upload_body: 'Your selection remains ready while this page stays open. Sign in to generate titles, descriptions, and keywords. Nothing has been uploaded yet.',
  login_upload_not_now: 'Not now',
  login_promo_byok_title: 'Free BYOK: 100/day with your own key',
  login_promo_byok_body: 'Sign in to use your API key for daily free runs or go Unlimited BYOK.',
  detail_status_waiting_credits: 'Waiting for credits',
  detail_status_waiting_credits_desc: 'Processing is paused for this file until credits are added.',
  detail_status_waiting_resources: 'Action required',
  detail_status_waiting_resources_desc: 'Add an API key or credits to continue processing this file.',
  detail_status_waiting_limit: 'Daily limit reached',
  detail_status_waiting_limit_desc: 'Go Unlimited BYOK or buy credits to continue processing this file.',
  detail_status_processing_desc: 'Processing is still running. Editing unlocks automatically when ready.',
  metadata_workspace_label: 'Metadata workspace',
  metadata_workspace_files: 'files',
  metadata_workspace_view_label: 'Workspace view',
  metadata_workspace_list_view: 'List',
  metadata_workspace_review_view: 'Review',
  metadata_workspace_resize_inspector: 'Resize metadata inspector',
  metadata_review_title: 'Image review',
  metadata_review_close: 'Back to list',
  metadata_review_previous: 'Previous file',
  metadata_review_next: 'Next file',
  metadata_review_fit: 'Fit',
  metadata_review_actual_size: '100%',
  metadata_review_zoom_out: 'Zoom out',
  metadata_review_zoom_in: 'Zoom in',
  metadata_review_enter_focus: 'Open focus mode',
  metadata_review_exit_focus: 'Exit focus mode',
  metadata_review_show_files: 'Show files',
  metadata_review_hide_files: 'Hide files',
  metadata_review_files: 'Files',
  metadata_review_preview_label: 'Large image preview',
  metadata_review_preview_alt: 'Preview of {filename}',
  metadata_review_no_selection: 'Select a file to preview',
  metadata_review_no_preview: 'A large preview is not available for this file',
  metadata_review_position: '{current} / {total}',
  metadata_review_ready: 'Ready',
  metadata_review_status_completed: 'Completed',
  metadata_review_status_queued: 'Queued',
  metadata_review_status_pending: 'Pending',
  metadata_review_status_manual: 'Waiting for Generate',
  metadata_review_status_paused: 'Paused',
  metadata_review_keyboard_shortcuts: 'Keyboard shortcuts',
  metadata_review_shortcut_help_title: 'Review shortcuts',
  metadata_review_shortcut_help_description: 'Shortcuts are paused while you type in a metadata field.',
  metadata_review_close_shortcut_help: 'Close shortcut guide',
  metadata_review_first_file: 'First file',
  metadata_review_last_file: 'Last file',
  metadata_review_shortcut_focus: 'Open or exit focus mode',
  metadata_review_shortcut_filmstrip: 'Show or hide the filmstrip',
  metadata_review_shortcut_escape: 'Close the guide, exit focus mode, or return to the list',
  metadata_review_shortcut_guide: 'Show or hide this shortcut guide',
  metadata_review_preview_loading: 'Preparing the large preview',
  metadata_review_processing_title: 'Creating metadata',
  metadata_review_processing_description: 'The preview stays available while analysis continues.',
  top_ai_edit_assistant: 'Open AI edit assistant for the selected file',
  top_ai_edit_select_file: 'Select a file before opening AI edit assistant',
  metadata_ai_title: 'AI Edit Assistant',
  metadata_ai_header_status: 'Edits the open metadata draft',
  metadata_ai_no_selection: 'No selected file',
  metadata_ai_close: 'Close AI edit assistant',
  metadata_ai_clear: 'Clear conversation',
  metadata_ai_platform_label: 'Platform',
  metadata_ai_view_label: 'Metadata platform',
  metadata_ai_view_default_short: 'Default',
  metadata_ai_view_getty_short: 'Getty/iStock',
  metadata_ai_scope_label: 'Field',
  metadata_ai_scope_all: 'All fields',
  metadata_ai_scope_title: 'Title',
  metadata_ai_scope_description: 'Description',
  metadata_ai_scope_keywords: 'Keywords',
  metadata_ai_scope_categories: 'Categories',
  metadata_ai_empty_title: 'What would you like to refine?',
  metadata_ai_empty_body: 'Choose a quick start or describe a precise change below.',
  metadata_ai_quick_shorten_title: 'Shorten the title',
  metadata_ai_quick_improve_description: 'Improve description',
  metadata_ai_quick_strongest_keywords: 'Keep strongest 20',
  metadata_ai_quick_fix_categories: 'Review categories',
  metadata_ai_prompt_shorten_title: 'Shorten the title while keeping the strongest searchable terms.',
  metadata_ai_prompt_shorten_getty_title: 'Shorten the Getty/iStock title while keeping the strongest searchable terms.',
  metadata_ai_prompt_improve_description: 'Rewrite the description to be concise, factual, and useful for search.',
  metadata_ai_prompt_improve_getty_description: 'Rewrite the Getty/iStock description to be concise, factual, and useful for search.',
  metadata_ai_prompt_strongest_keywords: 'Keep only the 20 strongest keywords and order them by relevance.',
  metadata_ai_prompt_strongest_getty_keywords: 'Keep only the 20 strongest Getty/iStock keywords and order them by relevance.',
  metadata_ai_prompt_fix_categories: 'Choose the most accurate Adobe Stock and Shutterstock categories for this image.',
  metadata_ai_assistant_label: 'AI',
  metadata_ai_user_label: 'You',
  metadata_ai_target_label: 'Target',
  metadata_ai_enter_hint: 'Enter to send · Shift+Enter for a new line',
  metadata_ai_input_label: 'AI edit instruction',
  metadata_ai_placeholder: 'Describe what should change in this draft…',
  metadata_ai_placeholder_scoped: 'Describe the change for {field}…',
  metadata_ai_send: 'Send edit request',
  metadata_ai_thinking: 'Reviewing this draft…',
  metadata_ai_finishing_file: 'Finishing the edit for {filename}…',
  metadata_ai_select_file: 'Open a file in the detail panel to use AI edit chat.',
  metadata_ai_helper: 'Clarifying questions are free; a request that returns an edit uses the allowance shown above.',
  metadata_ai_blocked: 'I could not start that edit right now.',
  metadata_ai_clarify: 'Which field should I change?',
  metadata_ai_applied: 'I updated the selected draft.',
  metadata_ai_error: 'I could not apply that edit. Name the exact field and desired change, then try again.',
  metadata_ai_file_unavailable: 'The file is no longer available, so I did not apply the edit.',
  metadata_ai_no_changes: 'The draft already matches that request, so no visible fields changed.',
  metadata_ai_conflict: 'This field changed while AI was working. Choose which version to keep.',
  metadata_ai_keep_current: 'Keep current',
  metadata_ai_apply_version: 'Apply AI version',
  metadata_ai_current_kept: 'Current draft kept',
  metadata_ai_changed_fields: 'Updated fields: {count}',
  metadata_ai_undo: 'Undo this edit',
  metadata_ai_reverted: 'Change reverted',
  metadata_ai_credit_used: 'Credits used: {count}',
  metadata_ai_request_billed: 'Request processed · {count} credit used',
  metadata_ai_keyword_count: '{count} keywords',
  metadata_ai_translation_count: '{count} translations',
  metadata_ai_field_title: 'Title',
  metadata_ai_field_description: 'Description',
  metadata_ai_field_keywords: 'Keywords',
  metadata_ai_field_adobe_category: 'Adobe category',
  metadata_ai_field_shutterstock_category: 'Shutterstock category',
  metadata_ai_field_getty_title: 'Getty/iStock title',
  metadata_ai_field_getty_description: 'Getty/iStock description',
  metadata_ai_field_getty_keywords: 'Getty/iStock keywords',
  metadata_ai_field_translated_title: 'Translated title',
  metadata_ai_field_translated_description: 'Translated description',
  metadata_ai_field_translated_keywords: 'Translated keywords',
  metadata_ai_billing_login_badge: 'Sign in',
  metadata_ai_billing_login_hint: 'Sign in to use AI edit chat. A request that returns an edit uses {count} credit(s).',
  metadata_ai_billing_byok_hint: 'Uses your own API key. AI edit requests do not use credits.',
  metadata_ai_billing_credit_badge: '{count} credit',
  metadata_ai_billing_fallback_credit_hint: 'Today\'s Free BYOK allowance is exhausted. Each request that returns an edit uses {count} credit(s) until it resets.',
  metadata_ai_billing_free_byok_badge: 'Free BYOK',
  metadata_ai_billing_limit_badge: 'BYOK limit',
  metadata_ai_billing_free_byok_hint: 'Uses Free BYOK allowance. {remaining}/{limit} assistant edits remain today.',
  metadata_ai_billing_limit_hint: 'Free BYOK daily limit reached. Add credits or upgrade to continue.',
  metadata_ai_billing_add_key_badge: 'Add key',
  metadata_ai_billing_add_key_hint: 'Add an API key or credits to use AI edit chat.',
  metadata_ai_billing_credit_hint: 'Each AI request that returns an edit uses {count} credit(s); changing more fields does not increase the cost.',

  auth_reset_invalid_or_expired: 'This password reset link is invalid or has expired. Please request a new one.',
  auth_verify_failed: 'Email verification failed. The link may be invalid or expired.',
  auth_invalid_action: 'Invalid action. Please check the link and try again.',
  auth_passwords_mismatch: 'Passwords do not match.',
  auth_password_min_length: 'Password must be at least 6 characters.',
  auth_reset_expired: 'This password reset link has expired. Please request a new one.',
  auth_reset_invalid: 'This password reset link is invalid. Please request a new one.',
  auth_password_weak: 'Password is too weak. Please choose a stronger password.',
  auth_reset_failed: 'Failed to reset password. Please try again.',
  auth_verifying_link: 'Verifying your link...',
  auth_reset_complete: 'Password Reset Complete',
  auth_email_verified: 'Email Verified',
  auth_reset_complete_body: 'Your password has been successfully reset. You can now sign in with your new password.',
  auth_email_verified_body: 'Your email has been successfully verified.',
  auth_continue_signin: 'Continue to Sign In',
  auth_error_title: 'Something went wrong',
  auth_back_to_signin: 'Back to Sign In',
  auth_back: 'Back',
  auth_reset_title: 'Reset Your Password',
  auth_new_password: 'New password',
  auth_confirm_password: 'Confirm new password',
  auth_resetting: 'Resetting...',
  auth_reset_button: 'Reset Password',
  auth_footer_prefix: 'By signing in, you agree to our',
  auth_terms: 'Terms of Service',
  auth_footer_and: 'and',
  auth_privacy: 'Privacy Policy',
  auth_legal_terms_prefix: 'By continuing, you agree to the',
  auth_legal_terms_suffix: '',
  auth_legal_privacy_prefix: 'You acknowledge that you have read the',
  auth_legal_privacy_suffix: '',
  auth_legal_info_prefix: 'Use of Stocktag is governed by the',
  auth_legal_info_privacy_prefix: 'Learn how data is processed in the',

  login_reset_link_sent: 'Password reset link has been sent to your email.',
  login_back: 'Back',
  login_workspace_subtitle: 'Continue with Google or your verified email account.',
  login_existing_users: 'Existing account sign-in',
  login_existing_users_title: 'Existing users only',
  login_existing_users_desc: 'Use your legacy email or phone sign-in until {date}. New accounts must continue with Google.',
  login_google_only_notice: 'New accounts are Google-only. Legacy email and phone sign-in are closed.',
  login_change_phone: 'Change phone number',
  login_show_password: 'Show password',
  login_hide_password: 'Hide password',
  login_continue_guest: 'Continue as guest',
  login_verifying: 'Verifying...',
  login_redirecting_google: 'Redirecting to Google...',
  login_continue_google: 'Continue with Google',
  login_signin_google: 'Sign in with Google',
  login_signup_google: 'Sign up with Google',
  login_signup_workspace_subtitle: 'Create your account with Google or a verified email address.',
  login_signup_google_notice: 'Your account is created securely with Google. No separate password is needed.',
  login_signup_email: 'Sign up with Email',
  login_email_signup_notice: 'Email accounts are activated only after a one-time code is verified.',
  login_email_signin_notice: 'Verified email accounts can sign in securely with their password.',
  login_or: 'or',
  login_signin_email: 'Sign in with Email',
  login_signin_phone: 'Sign in with Phone',
  login_email_signin_title: 'Sign In with Email',
  login_email_signin_desc: 'Use the email account you previously verified.',
  login_email_signup_title: 'Create an account with Email',
  login_email_signup_desc: 'We will send a 6-digit verification code to your email.',
  login_name_label: 'Name',
  login_password_requirements: 'Use at least 8 characters. A unique password is recommended.',
  login_create_email_account: 'Create account',
  login_email_verification_title: 'Verify your email',
  login_email_verification_desc: 'Enter the 6-digit code sent to {email}. It expires in 10 minutes.',
  login_verify_email_code: 'Verify and activate account',
  login_resend_email_code: 'Send a new code',
  login_resend_in: 'Resend in {seconds}s',
  login_change_email: 'Change email',
  login_email_code_sent: 'A new verification code has been sent.',
  login_error_email_in_use: 'An account already exists for this email. Sign in instead.',
  login_error_email_signup_unavailable: 'Email signup is temporarily unavailable. Please try again later.',
  login_error_weak_password: 'Use a password with at least 8 characters.',
  login_error_invalid_email: 'Enter a valid email address.',
  login_error_invalid_credentials: 'Email or password is incorrect.',
  login_error_invalid_code: 'The verification code is invalid.',
  login_error_expired_code: 'The verification code has expired. Request a new one.',
  login_error_too_many_attempts: 'Too many attempts. Please wait and try again.',
  login_error_delivery: 'The verification email could not be sent. Please try again.',
  login_error_security_verification: 'Security verification could not be completed. Please try again.',
  login_security_check_title: 'Security check',
  login_security_check_help: 'Complete this security check to continue.',
  login_security_loading: 'Loading security check…',
  login_security_verified: 'Security check completed',
  login_security_retry: 'Retry',
  login_error_security_required: 'Complete the security check to continue.',
  login_error_security_expired: 'The security check expired. Complete it again.',
  login_error_security_unavailable: 'The security check could not be loaded. Please retry.',
  login_error_security_network: 'The security check could not reach the server. Check your connection and retry.',
  login_error_security_timeout: 'The security check timed out. Please retry.',
  login_error_security_rejected: 'The security check was not accepted. Please complete it again.',
  login_error_request_timeout: 'The request took too long. Please try again.',
  login_error_network: 'Check your connection and try again.',
  login_error_account_disabled: 'This account is disabled. Contact support if you need help.',
  login_error_operation_in_progress: 'Please wait for the current request to finish.',
  login_error_generic: 'Something went wrong. Please try again.',
  login_email_placeholder: 'Email address',
  login_email_label: 'Email address',
  login_password_placeholder: 'Password',
  login_password_label: 'Password',
  login_signing_in: 'Signing in...',
  login_signin: 'Sign In',
  login_forgot_password: 'Forgot Password',
  login_create_account: 'Create Account',
  login_name_placeholder: 'Your name',
  login_password_min_placeholder: 'Password (min 6 characters)',
  login_creating_account: 'Creating account...',
  login_signup: 'Sign Up',
  login_have_account: 'Already have an account?',
  login_reset_password_title: 'Reset Password',
  login_reset_password_desc: 'Enter your email address and we\'ll send you a password reset link.',
  login_sending: 'Sending...',
  login_send_reset_link: 'Send Reset Link',
  login_phone_signin_title: 'Sign In with Phone',
  login_phone_signin_desc: 'Enter your phone number and we\'ll send you a verification code.',
  login_phone_placeholder: '+1 555 123 4567',
  login_phone_label: 'Phone number',
  login_sending_code: 'Sending code...',
  login_send_code: 'Send Verification Code',
  login_verify_code_title: 'Verify Code',
  login_verify_code_desc: 'Enter the 6-digit code sent to {phone}',
  login_code_placeholder: '000000',
  login_code_label: '6-digit verification code',
  login_verify_and_signin: 'Verify & Sign In',
  login_resend_code: 'Resend Code',
  login_close: 'Close',
  login_subtitle: 'Transform your media into professional stock content with the power of AI',
  login_byok_limit_reached: 'Daily free BYOK limit reached. Go Unlimited to remove limits.',
  login_feature_ai_analysis: 'AI Analysis',
  login_feature_auto_metadata: 'Auto Metadata',
  login_feature_seo: 'SEO Optimized',
  login_feature_multi_export: 'Multi Export',
  login_byok_title: 'Go Unlimited',
  login_byok_body_prefix: 'You have used today\'s free BYOK allowance. Upgrade to',
  login_byok_body_suffix: 'for {yearly} yearly or {monthly} monthly and remove daily limits.',
  login_byok_cta: 'Go Unlimited BYOK',
  login_not_now: 'Not now',
  login_byok_meta: 'Unlimited usage • Bring your own keys • No daily caps',
  login_benefits_title: 'Free BYOK: 100/day with your own key',
  login_benefit_unlimited: 'Unlimited BYOK upgrade available',
  login_benefit_cloud: 'Cloud sync & backup',
  login_benefit_analytics: 'Detailed analytics',
  login_recaptcha_prefix: 'This site is protected by reCAPTCHA Enterprise and the Google',
  login_recaptcha_privacy: 'Privacy Policy',
  login_recaptcha_terms: 'Terms of Service',
  login_recaptcha_suffix: 'apply.',

  credit_free_limit_1: 'Up to {limit} standard AI operations/day',
  credit_free_limit_2: 'Requires your own API key',
  credit_free_limit_3: 'No multi-key rotation',
  credit_free_limit_4: 'At most one request starts every {seconds} seconds',
  credit_free_limit_5: 'No priority support',
  credit_free_limit_6: 'Daily cap resets at 00:00 UTC',
  free_byok_speed_badge: 'Free BYOK · Standard queue',
  free_byok_speed_title: 'This batch is continuing in the Free BYOK queue',
  free_byok_speed_body: 'Processing is still active. Free BYOK starts at most one request every {seconds} seconds, so larger batches take longer. Your provider’s limits still apply.',
  free_byok_upgrade_hint: 'Credit plans use built-in AI without a key. Unlimited BYOK keeps your keys and removes Stocktag’s Free pacing and daily cap.',
  free_byok_compare_cta: 'Compare faster options',
  free_byok_keep_processing: 'Keep processing',
  free_byok_progress: '{processed}/{total} completed',
  credit_unlimited_feature_1: 'Unlimited metadata generation',
  credit_unlimited_feature_2: 'No daily caps',
  credit_unlimited_feature_3: 'Bring your own keys (OpenAI, Gemini, Claude, Groq, Grok)',
  credit_unlimited_feature_4: 'Multi-key rotation + failover',
  credit_unlimited_feature_5: 'No Stocktag Free pacing',
  credit_unlimited_feature_6: 'Priority support',
  credit_unlimited_feature_7: 'Full cost control with direct API calls',
  credit_checkout_failed: 'Failed to open checkout. Please try again.',
  credit_badge_popular: 'Most Popular',
  credit_badge_unlimited: 'Unlimited',
  credit_discount_label: '{percent}% OFF',
  credit_price_period_month: 'mo',
  credit_price_period_year: 'yr',
  credit_billed_yearly: 'Billed {price}/year',
  credit_save_amount: 'Save {amount}',
  credit_unlimited_usage: 'Unlimited usage',
  credit_credits_per_month: '{count} credits/mo',
  credit_manage_subscription: 'Manage Subscription',
  credit_processing: 'Processing...',
  credit_go_unlimited: 'Go Unlimited',
  credit_get_started: 'Get Started',
  credit_open_settings: 'Open Settings to add your API key.',
  credit_title: 'Faster processing options',
  credit_session_byok_title: 'Session paused at the Free BYOK limit',
  credit_session_byok_with_credits_body: '{waiting} file(s) are paused. Continue this session with your remaining credits, or buy more credits / Unlimited BYOK below.',
  credit_session_byok_body: '{waiting} file(s) are paused at the Free BYOK limit. Buy credits or switch to Unlimited BYOK to continue this open session.',
  credit_session_credits_title: 'Session paused because credits ran out',
  credit_session_credits_body: '{waiting} file(s) are waiting. Buy extra credits or move to a higher plan to continue this open session.',
  credit_session_resources_title: 'Session paused because an API key or credits are required',
  credit_session_resources_with_credits_body: '{waiting} file(s) are paused. Continue with your remaining credits, or buy more credits / Unlimited BYOK below. If you add an API key in Settings, this session will resume there as well.',
  credit_session_resources_body: '{waiting} file(s) are paused. Add an API key in Settings, buy credits, or switch plans to continue this open session.',
  credit_session_ready_export: '{count} ready file(s) can already be exported if you decide to stop here.',
  credit_session_continue_existing: 'Continue with {credits} credits',
  credit_session_stay_paused: 'Stay paused',
  history_draft_current_paused: 'Current paused session',
  free_byok_daily_counter: 'Daily remaining {remaining}',
  credit_current_balance: 'Current Balance',
  credit_units: 'credits',
  credit_save_up_to: 'Save up to 50%',
  credit_free_byok_badge: 'Free BYOK',
  credit_free_byok_tag: 'Up to {limit} standard AI operations/day',
  credit_free_byok_title: 'Daily free AI operations with your own API key',
  credit_free_byok_desc: 'Built for testing: up to {limit} standard AI operations/day in a paced queue. Optional extra operations count separately.',
  credit_add_api_key_settings: 'Add API Key in Settings',
  credit_signin_add_api_key: 'Sign In to Add API Key',
  credit_unlimited_byok_tag: '$3/mo yearly • $6/mo monthly',
  credit_unlimited_title: 'Unlimited, no caps, full control',
  credit_unlimited_desc: 'Everything unlocked for serious creators.',
  credit_unlimited_note: 'Add monthly or one-time credits whenever you need more capacity.',
  credit_yearly_price_label: 'Yearly {price}/mo',
  credit_monthly_price_label: 'Monthly {price}/mo',
  credit_billed_yearly_trial: 'Billed {price}/year • 1-day free trial',
  credit_billed_monthly: 'Billed monthly',
  credit_plans_title: 'Credit Plans',
  credit_plans_desc: 'Monthly credit plans use built-in AI without your own keys or Free BYOK pacing.',
  credit_onetime_hide: 'Hide Pay-as-you-go Credits',
  credit_onetime_show: 'No subscription? Show Pay-as-you-go Credits',
  credit_onetime_title: 'One-Time Credit Pack',
  credit_onetime_eyebrow: 'Pay as you go',
  credit_onetime_description: 'Use prepaid credits with no subscription, or add them on top of an active plan. Purchased credits do not expire.',
  credit_slider_title: 'Select Credit Amount',
  credit_slider_subtitle: 'Slide to choose how many credits you need',
  credit_slider_label: 'Credit quantity',
  credit_resume_queue_after_purchase: 'After payment is confirmed, automatically continue this {waiting}-file queue.',
  credit_currency_unit: 'USD',
  credit_onetime_feature_1: 'Never expires - use anytime',
  credit_onetime_feature_2: 'Works with or without a subscription',
  credit_onetime_feature_3: 'Instant activation after purchase',
  credit_topup_compatibility_title: 'Extra credits work with every membership',
  credit_topup_compatibility_body: 'Use them with Free / Pay as you go, any managed-credit plan, or Unlimited BYOK. Your current plan stays active, and purchased credits do not expire.',
  credit_buy_credits: 'Buy {credits} Credits for {price}',
  credit_secure_payment: 'Secure Payment via Paddle',
  credit_display_unlimited_title: 'Unlimited BYOK usage',
  credit_display_remaining: 'You have {count} credits remaining',
  credit_display_buy_more: 'Buy more credits',
  free: 'Free',
  plan_additional_credits: 'Additional Credits',
  plan_pay_as_you_go: 'Pay as you go',
  credit_member_badge: 'Credit member',
  credit_member_short: 'PAYG',
  pricing_title: 'Pricing Plans',
  pricing_subtitle: 'Choose the right plan for your creative workflow',
  pricing_simple_eyebrow: 'Simple, transparent pricing',
  pricing_simple_title: 'Choose based on how you want to work',
  pricing_simple_body: 'Use built-in credits for the easiest setup, buy a one-time top-up for short bursts, or bring your own API keys for full control.',
  pricing_handoff_title: 'Your selection is ready',
  pricing_handoff_subscription: 'We opened the monthly built-in credit option you chose. You can still change the volume.',
  pricing_handoff_topup: 'We opened the one-time credit option you chose. You can still switch paths at any time.',
  pricing_handoff_byok: 'We opened the own-key option you chose. Provider usage is billed separately.',
  pricing_behavior_insight_eyebrow: 'Based on your usage',
  pricing_behavior_insight_upgrade_title: '{plan} may fit your recurring extra credit needs better',
  pricing_behavior_insight_repeat_title: 'Consider {plan} for your recurring credit needs',
  pricing_behavior_insight_regular_title: '{plan} may fit your regular usage',
  pricing_behavior_insight_upgrade_body: 'Needing extra credits again on top of your current plan suggests that {credits} credits per month may be a steadier fit.',
  pricing_behavior_insight_repeat_body: 'Your recent one-time credit purchases point to a recurring need of about {forecast} credits per month. This plan includes {credits} credits per month.',
  pricing_behavior_insight_repeat_body_generic: 'You have needed one-time credits more than once recently. A monthly plan may provide a steadier fit if that pattern continues.',
  pricing_behavior_insight_regular_body: 'Your recent activity is about {forecast} credits per month. This plan includes {credits} credits per month, with room for normal variation.',
  pricing_behavior_insight_regular_body_generic: 'Your recent activity shows a regular usage pattern. A monthly plan may provide a steadier fit if that pattern continues.',
  pricing_behavior_insight_forecast: 'About {credits} credits/month',
  pricing_behavior_insight_plan_price: '{credits} credits · {price}/month',
  pricing_behavior_insight_saving: '{savings} less than the same one-time credit capacity',
  pricing_behavior_insight_note: 'This is only a suggestion. One-time credits do not expire; subscription credits refresh each billing period.',
  pricing_behavior_insight_primary: 'Review {plan}',
  pricing_behavior_insight_secondary: 'Continue with one-time credits',
  pricing_behavior_insight_dismiss: 'Hide this suggestion for 30 days',
  pricing_need_eyebrow: 'Start with your need',
  pricing_need_title: 'What fits your workflow today?',
  pricing_need_body: 'Pick one. You can switch paths at any time.',
  pricing_credit_guide_eyebrow: 'Know what your credits buy',
  pricing_credit_guide_title: 'One credit, clearly explained',
  pricing_credit_guide_body: 'Metadata generation is charged by media type. You see the estimate before processing.',
  pricing_fast_analysis_credit_title: 'Fast Analysis: {credits} credit',
  pricing_fast_analysis_credit_body: 'Professional metadata, fast results.',
  pricing_image_credit_title: 'Standard Analysis: {credits} credits',
  pricing_image_credit_body: 'Stronger context and keyword optimization.',
  pricing_video_credit_title: 'Video: 1 credit per {seconds} seconds',
  pricing_video_credit_body: 'A 60-second video uses {credits} credits. Each file rounds up to the next {seconds}-second block.',
  pricing_reasoning_credit_title: 'Deep Analysis: {credits} credits',
  pricing_reasoning_credit_body: 'Maximum analysis depth for complex content.',
  pricing_getty_credit_title: 'Getty/iStock: 1 request alone, 2 when combined',
  pricing_getty_credit_body: 'Getty/iStock alone has no extra charge beyond the selected analysis level. Combined with another metadata export, the second request adds {credits} credit per asset.',
  pricing_path_subscription_title: 'I work regularly',
  pricing_path_subscription_body: 'Monthly built-in AI credits. No API key needed.',
  pricing_path_topup_title: 'I need credits once',
  pricing_path_topup_body: 'One-time credits for a busy week or extra capacity.',
  pricing_path_byok_title: 'I have my own API key',
  pricing_path_byok_body: 'Unlimited BYOK with provider usage billed separately.',
  pricing_path_unsure_title: 'I’m not sure',
  pricing_path_unsure_body: 'Answer a few questions and see the best-fit option.',
  pricing_path_unsure_meta: 'Takes less than a minute',
  pricing_advisor_title: 'Let’s find the right option',
  pricing_advisor_body: 'Enter an approximate workload. You can change these answers at any time.',
  pricing_advisor_cadence: 'Is this recurring work?',
  pricing_advisor_regular: 'Every month',
  pricing_advisor_once: 'One-time job',
  pricing_advisor_images: 'Images per month / job',
  pricing_advisor_images_hint: '1 standard image uses {credits} credit',
  pricing_advisor_videos: 'Number of videos per month / job',
  pricing_advisor_videos_hint: 'Each video is rounded separately',
  pricing_advisor_video_seconds: 'Average length of each video (seconds)',
  pricing_advisor_video_cost_hint: '{credits} credits per video at this length',
  pricing_advisor_video_limit_hint: 'Maximum supported clip length is {seconds} seconds; mixed lengths may change the estimate.',
  pricing_advisor_extras: 'Optional processing',
  pricing_advisor_deep: 'Use Deep Analysis for images',
  pricing_advisor_deep_hint: '{deepCredits} credits per image instead of {standardCredits}',
  pricing_advisor_getty: 'Combine Getty/iStock with other metadata',
  pricing_advisor_getty_hint: 'A second AI request adds {credits} credit per asset. Getty/iStock alone has no extra charge.',
  pricing_advisor_own_key: 'I already manage my own AI API keys',
  pricing_advisor_own_key_hint: 'Choose this for direct provider billing with Free or Unlimited BYOK.',
  pricing_advisor_estimate: 'Estimated need',
  pricing_advisor_credit_equivalent: 'Built-in AI equivalent',
  pricing_advisor_result_byok: 'Best fit: Unlimited BYOK',
  pricing_advisor_result_topup: 'Best fit: one-time credit pack',
  pricing_advisor_result_plan: 'Best fit: {plan} · {period}',
  pricing_advisor_period_monthly: 'monthly billing',
  pricing_advisor_period_yearly: 'yearly billing',
  pricing_advisor_result_empty: 'Add at least one image or video to get a recommendation',
  pricing_advisor_show: 'Show my recommendation',
  pricing_advisor_shortfall: 'This exceeds the largest monthly plan by {credits} credits; add a one-time top-up for the difference.',
  pricing_advisor_topup_shortfall: 'The largest selectable one-time pack is {credits} credits short; use a monthly plan plus a top-up or contact support.',
  pricing_recommended_badge: 'Recommended for you',
  pricing_selected_badge: 'Selected',
  pricing_starts_at_price: 'From {price}/mo',
  pricing_byok_price_summary: '{yearly}/mo yearly · {monthly}/mo monthly',
  pricing_subscription_heading: 'Choose your monthly credit volume',
  pricing_subscription_body: 'Every monthly plan includes the same production tools. Fast is for everyday output, Standard provides more advanced results, and Deep Analysis is for complex content; choose your credit volume accordingly.',
  pricing_per_100_credits: '{price} per 100 credits',
  pricing_plan_capacity: '{images} standard images or about {minutes} total video min across clips (max {maxSeconds}s each)',
  pricing_plan_image_capacity: 'Image capacity: {fast} Fast · {standard} Standard · {deep} Deep Analysis',
  pricing_plan_video_capacity: 'Video capacity: about {clips} × 60-sec clips',
  pricing_plan_video_rate: 'Video: {seconds} sec = 1 credit · max {maxSeconds} sec per clip',
  pricing_queue_covered: 'Covers this queue with {credits} credits left',
  pricing_queue_short: '{credits} more credits needed for this queue',
  pricing_recommendation_capacity_shortfall: 'Largest available plan; the estimate still exceeds it by {credits} credits. Add a one-time top-up for the difference.',
  pricing_subscription_reset_note: 'Subscription credits refresh each allocation period; unused subscription credits do not roll over. One-time credits remain separate and do not expire.',
  pricing_advisor_plan_detail: '{credits} credits/month · {headroom} credits headroom · {price}/month equivalent',
  pricing_advisor_topup_detail: 'Buy {quantity} × {packCredits} credits = {credits} credits for {price}',
  pricing_advisor_result_current_plan: 'Your current {plan} plan already covers this workload.',
  pricing_advisor_result_balance: 'Your current credit balance already covers this one-time job.',
  pricing_advisor_no_purchase: 'No purchase needed',
  pricing_advisor_result_free_byok: 'Best fit: Free BYOK with your own API key',
  pricing_advisor_unlimited_need: 'I need to remove the Free BYOK daily cap and pacing',
  pricing_advisor_unlimited_need_hint: 'Choose this for more than {limit} standard AI operations/day or faster throughput.',
  pricing_plan_finder_link: 'Answer a few questions in the full plan finder',
  pricing_preference_managed_body: 'Built-in AI, no API key',
  pricing_preference_byok_title: 'Use your own API key',
  pricing_preference_byok_body: 'Provider usage billed separately',
  pricing_compare_eyebrow: 'Before you buy',
  pricing_compare_title: 'Compare credit options',
  pricing_compare_body: 'Compare credit allocation, renewal, validity and workload fit.',
  pricing_compare_detail: 'Detail',
  pricing_compare_setup: 'Setup',
  pricing_compare_setup_managed: 'Built-in AI; no API key',
  pricing_compare_setup_byok: 'Your provider account and API keys',
  pricing_compare_payment: 'Payment',
  pricing_compare_payment_subscription: 'Recurring monthly or yearly billing',
  pricing_compare_payment_once: 'One-time payment',
  pricing_compare_payment_free_byok: 'No Stocktag fee; provider usage only',
  pricing_compare_payment_byok: 'Stocktag subscription + provider usage',
  pricing_compare_validity: 'Usage allowance',
  pricing_compare_validity_subscription: 'Refreshes each allocation period; no rollover',
  pricing_compare_validity_once: 'Stacks and does not expire',
  pricing_compare_validity_free_byok: 'Up to {limit} standard AI operations/day in a paced queue; provider limits apply',
  pricing_compare_validity_byok: 'No Stocktag metadata cap; provider limits apply',
  pricing_compare_extra_cost: 'Separate AI provider fee',
  pricing_compare_no: 'No',
  pricing_compare_yes: 'Yes',
  pricing_compare_best_for: 'Best for',
  pricing_compare_best_subscription: 'Predictable recurring production',
  pricing_compare_best_once: 'A short project or overflow',
  pricing_compare_best_free_byok: 'Testing and lighter own-key workflows',
  pricing_compare_best_byok: 'High volume and direct API control',
  pricing_choose_plan: 'Choose {plan}',
  pricing_annual_savings_included: 'Annual savings included',
  pricing_topup_heading: 'Buy only the extra credits you need',
  pricing_topup_body: 'A one-time purchase with no subscription. Your total is shown before checkout.',
  pricing_byok_heading: 'Use your own keys without Stocktag daily caps',
  pricing_byok_body: 'Best if you already manage API keys and want direct control. Your AI provider bills its own usage separately.',
  pricing_provider_fees_title: 'Two separate costs',
  pricing_change_plan: 'Change plan in billing portal',
  pricing_no_management_url: 'No management URL found. Please contact support.',
  pricing_management_failed: 'Could not open subscription management. Please contact support.',
  pricing_primary_cta: 'Explore Unlimited BYOK',
  pricing_secondary_cta: 'See credit plans',
  pricing_clear_billing: 'Clear billing before checkout',
  pricing_billing_label: 'Billing period',
  pricing_save_up_to: 'Save up to {percent}%',
  pricing_yearly_value: 'Lower monthly price, billed yearly',
  pricing_monthly_value: 'Flexible month-to-month billing',
  pricing_period_unavailable: 'This option is not available for the selected billing period.',
  pricing_unavailable: 'Unavailable',
  pricing_catalog_unavailable: 'Live prices could not be verified. Purchases are paused.',
  pricing_retry: 'Retry',
  pricing_loading_plans: 'Confirming prices...',
  pricing_two_models: 'Two ways to work',
  pricing_choose_model: 'Choose who powers the AI',
  pricing_choose_model_body: 'Use your own API keys for full control, or built-in credits for the simplest setup.',
  pricing_provider_fees_note: 'AI provider usage is billed separately by your provider.',
  pricing_built_in_ai: 'Built-in AI',
  pricing_starts_at: 'Starts at',
  pricing_credit_range: 'Credit range',
  pricing_credit_benefit_no_keys: 'No API key setup',
  pricing_credit_benefit_predictable: 'Clear credit allowance',
  pricing_credit_benefit_scale: 'Scale from solo work to agency volume',
  pricing_compare_credit_plans: 'Compare credit plans',
  pricing_credit_plans_body: 'Built-in AI credits with no API key setup or provider account required.',
  pricing_no_keys_needed: 'No keys needed',
  pricing_topup_eyebrow: 'For busy weeks and overflow',
  pricing_customize_pack: 'Customize pack',
  pricing_topup_title: 'Add exactly the capacity you need',
  pricing_total: 'Total',
  pricing_quick_select: 'Quick select',
  pricing_usd_notice: 'Prices shown in {currency}',
  pricing_checkout_notice: 'Review the total before payment',
  pricing_legal_links: 'Pricing legal links',
  pricing_plan_recommended: 'Best balance',
  pricing_current_plan: 'Current plan',
  pricing_regular_price: 'Regular price',
  pricing_plan_starter_desc: 'For small, occasional content batches',
  pricing_plan_growth_desc: 'For regular portfolio uploads',
  pricing_plan_pro_desc: 'For weekly batch production',
  pricing_plan_agency_desc: 'For large portfolios and multi-marketplace workflows',
  pricing_plan_scale_desc: 'For intensive daily production and maximum credit volume',
  pricing_feature_metadata_suite: 'AI titles, descriptions, and keywords for images and video',
  pricing_feature_analysis_levels: 'Fast, Standard, and Deep Analysis with custom metadata rules',
  pricing_feature_export_suite: '15+ marketplace CSVs, Custom CSV, and embedded IPTC/XMP',
  pricing_feature_review_suite: 'Bulk editing, metadata QA, and commercial-rights checks',
  pricing_feature_language_suite: 'Multilingual metadata and automatic translation',
  pricing_feature_intelligence_suite: 'Trends Radar, Similarity Scanner, history, and recovery',
  pricing_feature_support_suite: 'Help Center and email support',
  pricing_feature_ai_metadata: 'AI metadata generation',
  pricing_feature_basic_support: 'Basic support',
  pricing_feature_priority_support: 'Priority support',
  pricing_feature_premium_support: 'Premium support',
  pricing_feature_bulk_processing: 'Bulk processing',
  pricing_feature_advanced: 'Advanced features',
  pricing_feature_all: 'All features',
  pricing_feature_api_access: 'API access',
  pricing_feature_bonus_months: '{count} months of savings included',
  free_credits_signin_generate_link: 'Please sign in to generate your referral link.',
  free_credits_copy_success: 'Referral link copied to clipboard.',
  free_credits_copy_failed: 'Could not copy the referral link.',
  free_credits_share_title: 'Stocktag Referral',
  free_credits_share_text: 'Join Stocktag with my link and get started.',
  free_credits_subtitle: 'Share your referral link. Earn %%CREDITS%% credits when an eligible new signup completes the required checks.',
  free_credits_credits_amount: '{credits} credits',
  free_credits_title: 'Free Credits',
  free_credits_badge: '{credits} credits per eligible referral',
  free_credits_link_title: 'Your referral link',
  free_credits_link_hint: 'Share it anywhere.',
  free_credits_link_signin_hint: 'Sign in to generate your link.',
  free_credits_share: 'Share',
  free_credits_link_placeholder: 'Sign in to generate your link',
  free_credits_copy: 'Copy',
  free_credits_total_referrals: 'Total referrals',
  free_credits_earned: 'Credits earned',
  free_credits_note: 'Rewards are issued once per eligible new account after eligibility and abuse-prevention checks.',
  free_credits_referral_joined: 'Referral joined',
  free_credits_no_referrals: 'No referrals yet. Share your link to get started.',
  free_credits_signin_start: 'Sign in to start earning free credits.',
  free_credits_need_help: 'Need help?',
  free_credits_help_text: 'For any questions about credits or referrals, contact our support team.',
  free_credits_email_support: 'Email support',
  free_credits_how_it_works: 'How it works',
  free_credits_step_1: '1) Copy your link',
  free_credits_step_2: '2) Your friend creates an eligible new account',
  free_credits_step_3: '3) You receive {credits} credits after the checks',
  ai_assistant_title: 'AI Assistant',
  ai_assistant_selected_count: '{count} files selected',
  ai_assistant_placeholder_quick: "e.g., 'add keyword: vintage', 'remove keyword: abstract', 'prefix title: Premium'...",
  ai_assistant_placeholder_regenerate: 'Custom instructions for AI regeneration...',
  ai_assistant_hint_quick: 'Quick edits are processed locally - no credits used',
  ai_assistant_hint_unlimited: 'Unlimited BYOK plan - No credits needed for regeneration',
  ai_assistant_hint_credits: 'Regeneration uses 1 credit per file ({credits} credits total)',
  auth_modal_close: 'Close',
  auth_modal_title: 'Sign in',
  auth_modal_subtitle: 'Log in with your Google account to unlock all tools.',
  auth_modal_error: 'An error occurred during sign-in. Please try again.',
  auth_modal_benefit_1: 'Generate titles, descriptions and keywords with Stocktag credits',
  auth_modal_benefit_2: 'Download CSV & JSON outputs',
  auth_modal_benefit_3: 'Continue with a monthly credit plan or one-time credits',
  auth_modal_footer_prefix: 'By continuing, you agree to our',
  folder_panel_confirm_delete: 'Are you sure you want to delete {count} folder(s)?',
  folder_panel_title: 'Folders',
  folder_panel_search_placeholder: 'Search folders...',
  folder_panel_cancel: 'Cancel',
  folder_panel_select: 'Select',
  folder_panel_delete: 'Delete ({count})',
  folder_panel_empty: 'No folders found',
  folder_panel_files: '{count} files',
  shortcuts_nav_label: 'Navigate',
  shortcuts_prev_file_title: 'Previous File ({shortcut})',
  shortcuts_next_file_title: 'Next File ({shortcut})',
  shortcuts_edit_label: 'Edit',
  shortcuts_undo_title: 'Undo ({shortcut})',
  shortcuts_undo: 'Undo',
  shortcuts_redo_title: 'Redo ({shortcut})',
  shortcuts_redo: 'Redo',
  shortcuts_copy_title: 'Copy Metadata ({shortcut})',
  shortcuts_copy: 'Copy',
  shortcuts_paste_title: 'Paste Metadata ({shortcut})',
  shortcuts_paste: 'Paste',
  shortcuts_paste_selected: 'Paste ({count})',
  shortcuts_actions_label: 'Actions',
  shortcuts_save_title: 'Save Changes ({shortcut})',
  shortcuts_save: 'Save',
  shortcuts_save_selected: 'Save ({count})',
  shortcuts_save_all_title: 'Save all unsaved metadata changes',
  shortcuts_save_all: 'All',
  shortcuts_context_selected: '{count} selected',
  shortcuts_context_unsaved: '{count} unsaved',
  shortcuts_context_progress: '{processed}/{total} ready',
  shortcuts_context_ready: '{count} ready',
  shortcuts_export_unavailable: 'Add files to enable CSV export',
  shortcuts_embed_unavailable: 'Generate at least one file to enable embed export',
  shortcuts_regenerate_title: 'Regenerate ({shortcut})',
  shortcuts_regenerate_all: 'Regenerate All ({count})',
  shortcuts_regenerate: 'Regenerate',
  shortcuts_ai_assistant_title: 'AI Assistant - Quick edits and custom regeneration',
  shortcuts_ai_label: 'AI',
  shortcuts_delete_title: 'Remove ({shortcut})',
  shortcuts_delete: 'Delete',
  shortcuts_delete_selected: 'Delete ({count})',
  shortcuts_remove_from_session: 'Remove from session',
  listview_remove_confirm_title: 'Remove selected files?',
  listview_remove_single_confirm_title: 'Remove this file?',
  listview_remove_confirm_body: '{count} selected files will be removed from this session. You can undo this action.',
  listview_remove_confirm_unsaved_body: '{count} selected files include {unsaved} unsaved edit(s). Remove them from this session?',
  listview_remove_single_unsaved_body: 'This file has unsaved edits. Remove it from this session?',
  listview_removed_notice: '{count} file(s) removed from this session. Undo is available.',
  listview_removed_single_notice: 'File removed from this session. Undo is available.',
  metadata_ai_disclaimer: 'AI can make mistakes. Check important information.',
  shortcuts_all_title: 'All Shortcuts ({shortcut})',
  listview_empty: 'No processed files yet.',
  listview_selected_count: '{count} selected',
  listview_selected_visible: '{count} visible',
  listview_selected_hidden: '{count} hidden by filters',
  listview_selection_focus: 'Focus: {name}',
  listview_selection_reveal: 'Reveal in list',
  listview_selection_hint: 'Use Shift+Click or Shift+↑/↓ for range selection',
  listview_selection_actions: 'Selection tools',
  listview_rights_audit_action: 'GPT-5.4 double commercial audit • {credits} credits ({count} × 2)',
  listview_rights_audit_byok_action: 'GPT-5.4 double commercial audit • BYOK 0 credits ({count} × 2)',
  listview_rights_audit_credit_first_action: 'GPT-5.4 double commercial audit • credits first, then BYOK ({count} × 2)',
  listview_rights_audit_description: 'Runs two independent GPT-5.4 checks on completed commercial metadata while its original visual is still accessible. Editorial items are not changed.',
  listview_rights_audit_progress: 'Commercial audit {done}/{total}',
  listview_rights_audit_queued: 'Commercial audit queued ({count})',
  listview_rights_audit_queued_notice: 'The commercial rights audit was queued and will start automatically after the current metadata work finishes.',
  listview_rights_audit_complete: 'Double-layer commercial rights verification completed for {count} item(s).',
  listview_rights_audit_partial: '{count} item(s) could not be verified: {message}',
  listview_rights_audit_skipped: '{count} selected item(s) were skipped because they are editorial, incomplete, or their original visual is no longer accessible.',
  listview_rights_audit_no_visual: 'No selected commercial item is complete and still has an accessible original visual.',
  listview_rights_audit_saved_original_draft: 'The workspace changed during the audit. Completed results were saved to the original draft history.',
  listview_rights_audit_not_entitled: 'Double-layer commercial rights verification is not enabled for this account.',
  listview_rights_audit_insufficient_credits: 'This audit requires {required} credits; your balance is {available}.',
  listview_rights_audit_balance_changed: 'The audit stopped because the available credit balance changed.',
  listview_rights_audit_byok_openai_key_required: 'Connect an OpenAI API key to run the GPT-5.4 audit with BYOK.',
  listview_select_visible: 'Visible',
  listview_select_invert: 'Invert visible',
  listview_select_unsaved: 'Unsaved',
  listview_select_errors: 'Errors',
  listview_select_processing: 'Processing',
  listview_select_clear: 'Clear',
  listview_clear_selection: 'Clear selection',
  listview_select_all_visible: 'Select all visible results',
  listview_select_file: 'Select file',
  listview_column_filename: 'Filename',
  listview_column_title: 'Title',
  listview_column_description: 'Description',
  listview_column_keywords: 'Keywords',
  listview_column_status: 'Status',
  listview_bulk_editor_title: 'Bulk edit',
  listview_bulk_editor_scope: '{count} selected files',
  listview_bulk_editor_heading: 'Choose a field, then an operation',
  listview_bulk_editor_draft_note: 'Apply creates an unsaved draft. You can review, undo, or save it afterward.',
  listview_bulk_field_label: 'Metadata field',
  listview_bulk_operation_label: 'Operation',
  listview_bulk_field_keywords: 'Keywords',
  listview_bulk_field_title: 'Title',
  listview_bulk_field_description: 'Description',
  listview_bulk_field_all: 'All main fields',
  listview_bulk_action_add_keyword: 'Add keywords',
  listview_bulk_action_add_keyword_help: 'Add one or more comma-separated keywords to the beginning of each list.',
  listview_bulk_action_remove_keyword: 'Remove keywords',
  listview_bulk_action_remove_keyword_help: 'Remove exact keyword matches; separate multiple values with commas.',
  listview_bulk_action_clear_keywords: 'Clear keywords',
  listview_bulk_action_clear_keywords_help: 'Remove all primary keywords from matching files.',
  listview_bulk_action_prefix_title: 'Add title prefix',
  listview_bulk_action_prefix_title_help: 'Insert the same text at the beginning of each title.',
  listview_bulk_action_suffix_title: 'Add title suffix',
  listview_bulk_action_suffix_title_help: 'Append the same text to the end of each title.',
  listview_bulk_action_clear_title: 'Clear titles',
  listview_bulk_action_clear_title_help: 'Remove the primary title from matching files.',
  listview_bulk_action_clear_description: 'Clear descriptions',
  listview_bulk_action_clear_description_help: 'Remove the primary description from matching files.',
  listview_bulk_action_replace_text: 'Find and replace',
  listview_bulk_action_replace_text_help: 'Search primary titles, descriptions, and keywords without case sensitivity.',
  listview_bulk_action_clear_all: 'Clear all metadata',
  listview_bulk_action_clear_all_help: 'Clear primary metadata, Getty/iStock fields, categories, and translations.',
  listview_bulk_keywords_input_label: 'Keywords (comma separated)',
  listview_bulk_keywords_input_placeholder: 'nature, landscape, outdoors',
  listview_bulk_text_input_label: 'Text',
  listview_bulk_text_input_placeholder: 'Enter text',
  listview_bulk_find_input: 'Find text',
  listview_bulk_find_placeholder: 'Text to find',
  listview_bulk_replace_input: 'Replace with',
  listview_bulk_replace_placeholder: 'Leave empty to remove',
  listview_bulk_preview_none_editable: 'Selected files are still processing or waiting.',
  listview_bulk_preview_input_required: 'Enter a value to calculate the impact.',
  listview_bulk_preview_no_changes: 'No selected metadata matches this operation.',
  listview_bulk_preview_changes: '{affected} of {eligible} files will change · {fields} field updates',
  listview_bulk_hidden_scope_notice: '{count} selected files are hidden by the current filters and are included.',
  listview_bulk_skipped_processing: '{count} processing or waiting files will be skipped.',
  listview_bulk_confirm_destructive: 'I confirm clearing metadata in {count} files.',
  listview_bulk_result_success: '{count} files updated as drafts.',
  listview_bulk_save_selected: 'Save drafts ({count})',
  listview_bulk_apply_count: 'Apply to {count} files',
  listview_bulk_cancel: 'Cancel',
  listview_bulk_regenerate: 'Regenerate',
  listview_bulk_delete: 'Delete',
  folder_expired: 'Expired',
  folder_expires_hours: 'Expires in {count} hours',
  folder_expires_hour: 'Expires in {count} hour',
  folder_expires_days: 'Expires in {count} days',
  folder_expires_day: 'Expires in {count} day',
  thumbnail_loading_video: 'Loading video preview...',
  thumbnail_regenerating: 'Regenerating metadata...',
  thumbnail_regenerate: 'Regenerate metadata (credit use is confirmed before processing)',
  thumbnail_generation_failed: 'Thumbnail generation failed.',
  notification_just_now: 'Just now',
  notification_minutes_ago: '{count}m ago',
  notification_hours_ago: '{count}h ago',
  notification_title: 'Notifications',
  notification_metadata_ready: '{completed}/{total} files processed and ready to export.',
  notification_metadata_review: '{completed}/{total} completed · {review} need review.',
  notification_mark_all: 'Mark all as read',
  notification_clear_history: 'Clear history',
  notification_empty: 'No notifications yet',
  shortcuts_panel_title: 'Keyboard Shortcuts',
  shortcuts_panel_hint: 'Press %%KEYS%% to toggle this panel',
  loading_text: 'Loading',
  loading_badge: 'AI Metadata',
  loading_headline: 'AI is preparing stock metadata',
  loading_description: 'Title • Description • Keywords',
  loading_status_detail: 'Analyzing the image',
  loading_signal_search: 'Search-intent aligned',
  loading_signal_precision: 'Clean keyword structure',
  loading_signal_output: 'Stock-ready output',
  loading_visual_caption: 'Title, description, keywords.',
  loading_card_title: 'Title',
  loading_card_description: 'Description',
  loading_card_keywords: 'Keywords',
  loading_stage_vision: 'Analysis',
  loading_stage_metadata: 'Metadata',
  loading_stage_ready: 'Ready',
  loading_proof_title_label: 'Titles',
  loading_proof_title_value: 'Search-intent aligned',
  loading_proof_description_label: 'Descriptions',
  loading_proof_description_value: 'Cleaner, readable copy',
  loading_proof_keywords_label: 'Keywords',
  loading_proof_keywords_value: 'Balanced relevant set',
  help_eyebrow: 'Help Center',
  help_changelog_eyebrow: 'Help Center',
  help_changelog_title: 'Changelog',
  help_changelog_subtitle: 'See the latest Stocktag features, fixes, and improvements.',
  help_changelog_overview_title: 'Latest updates',
  help_changelog_overview_body: 'We ship improvements weekly. This page highlights the most recent product changes.',
  help_changelog_recent_title: 'Recent releases',
  help_changelog_recent_body: 'Date-by-date summary of product updates and fixes.',
  help_changelog_badge: 'Update',
  changelog_2026_08_30_1_title: 'Generate metadata in 7 languages',
  changelog_2026_08_30_1: 'Metadata Studio can now create titles, descriptions, and keywords directly in English, Spanish, French, German, Italian, Portuguese, or Japanese. Choose the language once and new generations will use it automatically.',
  changelog_2026_08_30_1_link: 'Choose metadata language',
  changelog_2026_08_30_2_title: 'Metadata settings are easier to use',
  changelog_2026_08_30_2: 'Metadata settings now have a clearer, more compact layout. Your current choices are summarized at the top, related controls are grouped, and changes are saved automatically.',
  changelog_2026_08_30_2_link: 'Open metadata settings',
  changelog_2026_08_30_3_title: 'Smarter keyword counts without filler',
  changelog_2026_08_30_3: 'Smart keyword mode now lets AI stop when every useful, distinct search term is covered. It no longer pads the list with weak words just to reach a fixed number; choose Fixed count only when an exact amount is required.',
  changelog_2026_08_30_3_link: 'Open Smart keyword settings',
  changelog_2026_08_25_1: 'Metadata Studio workflows are now easier to resume and reuse, with saved settings templates, clearer recovery for interrupted sessions, and safer handoffs when work continues across tabs or after sign-in.',
  changelog_2026_08_25_2: 'Getty Images and iStock workflows have been expanded, making it easier to prepare metadata and keywords for these destinations.',
  changelog_2026_08_25_3: 'File understanding and trend guidance have been refined, so suggestions can better reflect the type of content you are working with and the planning context around it.',
  changelog_2026_08_25_4: 'Free BYOK, credits, and subscription guidance is clearer, with more helpful capacity reminders and smoother continuation after account or purchase changes.',
  changelog_2026_08_25_5: 'Returning users and guests have a clearer path from saved work or a local preview into the full studio, with fewer interruptions when moving into an account.',
  changelog_2026_08_25_6: 'Bengali, Hindi, and Brazilian Portuguese coverage has been added across core product, help, legal, marketing, and discovery content.',
  changelog_2026_08_25_7: 'Help, blog, comparison, and product-discovery content has been refreshed so it is easier to understand what Stocktag offers and how each workflow fits.',
  changelog_2026_08_25_8: 'Everyday reliability has been strengthened across metadata generation, export, support, and account flows, with clearer feedback when an action needs attention.',
  changelog_2026_08_09_1: 'Stocktag’s public homepage and navigation have been redesigned with clearer product guidance, real workflow examples, easier access to tools, and new About, Contact, and Editorial Policy pages.',
  changelog_2026_08_09_2: 'Metadata Studio’s upload screen now lets you drop files anywhere in the frame, clearly choose Standard, PNG, or Vector workflows, and review the settings that will be used before generation starts.',
  changelog_2026_08_09_3: 'A new AI Edit Assistant can refine a selected file’s title, description, keywords, and categories through a simple conversation. You can review exactly what changed, keep your own edits, or undo the AI result.',
  changelog_2026_08_09_4: 'Batch cleanup is faster with a new bulk editor for selected files: add or remove keywords, add title prefixes or suffixes, find and replace text, preview the impact, undo, and save when ready.',
  changelog_2026_08_09_5: 'History now keeps your latest unfinished work in one clear place, autosaves progress, and lets you prepare or download the normal CSV ZIP without duplicate recovery entries.',
  changelog_2026_08_09_6: 'The Vectorizer has been rebuilt with clearer batch progress, better previews, individual SVG downloads, and one-click ZIP export. Image and EPS preparation is also more responsive and gives clearer guidance when something goes wrong.',
  changelog_2026_08_09_7: 'Plans, one-time credits, and purchase confirmation are easier to understand. Purchased credits are clearly distinguished from subscriptions, successful payments activate more smoothly, and delayed activations continue syncing without asking you to pay again.',
  changelog_2026_08_09_8: 'Help and support are easier to reach with guided answers, a clearer handoff to human support, and a more reliable conversation inbox. Rights warnings and export guidance are also simpler, helping you make the final licensing decision without unexpectedly blocking completed work.',
  changelog_2026_07_26_1: 'Metadata review has been refreshed with larger image and video previews, faster file navigation, focus and zoom tools, keyboard shortcuts, and editing actions brought together in one smoother workspace.',
  changelog_2026_07_26_2: 'Commercial and editorial usage choices are now available, with an optional rights review that highlights possible brands, logos, characters, artworks, distinctive products, and similar protected elements using clearer findings and research references to support your checks before commercial use.',
  changelog_2026_07_26_3: 'Completed commercial files can also be reviewed again in bulk for possible rights concerns before export, without having to recreate otherwise ready metadata.',
  changelog_2026_07_26_4: 'Working across multiple browser tabs is now safer: overlapping jobs stay queued, completed results are preserved, and duplicate work or unintended credit use is prevented.',
  changelog_2026_07_26_5: 'Metadata generation, regeneration, and refinement are more reliable when requests repeat, connections drop, files move, a task is cancelled, or a session is interrupted.',
  changelog_2026_07_26_6: 'Credit and pricing guidance is clearer, with upfront workload estimates, recommendations based on your needs, easier comparison of recurring credits, one-time top-ups, and your own AI account, plus safer continuation after a purchase.',
  changelog_2026_07_26_7: 'Credit balances and subscription allowances now remain more consistent through renewals, retries, and interrupted processing, while completed work stays available whenever possible.',
  changelog_2026_07_26_8: 'Using your own AI account has been updated with current service and model choices, smoother migration from older selections, clearer compatibility guidance, and more dependable request handling.',
  changelog_2026_07_26_9: 'Marketplace-specific metadata has been polished so titles, descriptions, and keywords follow each destination’s formatting and length expectations more consistently.',
  changelog_2026_07_18_1: 'AI Image Studio has been renewed with more model choices, reference-based editing, flexible output settings, and easier preview, reuse, and bulk download tools.',
  changelog_2026_07_18_2: 'The Help Center and support assistant now offer smarter search, step-by-step troubleshooting, visual guides, verified answers, and clearer access to human support.',
  changelog_2026_07_18_3: 'Pricing and purchasing have been reorganized so monthly credits, one-time credit packs, and using your own AI provider account are easier to compare.',
  changelog_2026_07_18_4: 'Payments, subscription renewals, credit balances, and post-purchase continuation are now more reliable, helping purchased access appear on accounts more consistently.',
  changelog_2026_07_18_5: 'Navigation, account settings, and key screens have been refreshed, making tools, API keys, preferences, billing, and quick actions easier to reach on desktop and mobile.',
  changelog_2026_07_18_6: 'Metadata settings and export tools have improved, with more flexible content-length controls, safer CSV template editing, and easier management of marketplace export options.',
  changelog_2026_07_18_7: 'Metadata processing, credit use, history, and session recovery have been strengthened, making long sessions more consistent and interrupted tasks easier to find and continue.',
  changelog_2026_07_18_8: 'Bring-your-own-key support has expanded with current model choices, clearer key checks, and more predictable processing guidance across supported services.',
  changelog_2026_07_18_9: 'Signup and referral credit flows have improved, making eligible rewards and referral history more dependable.',
  changelog_2026_07_18_10: 'Privacy choices and public community areas are now clearer, with more transparent guidance for cookies, newsletters, feedback, and support.',
  changelog_2026_04_03_1: 'The metadata runtime now tracks each request and autosave step more closely, so long batch sessions recover more cleanly, regeneration is less likely to stall, and active jobs are easier to resume after interruptions.',
  changelog_2026_04_03_2: 'History and recovery flows were strengthened: paused jobs can backfill more reliably, draft data can be downloaded as recovery ZIPs, and storage-backed recovery helps reopen work that did not finish normally.',
  changelog_2026_04_03_3: 'A reusable Custom CSV Builder was added for export-heavy workflows, letting you design column layouts, preview sample rows, save your own templates, and keep per-site CSV overrides instead of remapping fields every time.',
  changelog_2026_04_03_4: 'Signup and free-credit protection was tightened with stronger verification and abuse checks, which reduces fake signups and keeps access more stable for real users.',
  changelog_2026_04_03_5: 'Indonesian and Thai coverage expanded across the app, help pages, legal pages, blog content, tool landing pages, and SEO routes, so more users can use the product end to end in their own language.',
  changelog_2026_03_30_1: 'Italian localization is now live across the main product surfaces, including navigation, metadata flows, pricing, help, legal pages, blog content, and SEO routes, so Italian-speaking users can work end to end in one language.',
  changelog_2026_03_30_2: 'A new Community Feedback board was added, giving users one shared place to post feature requests, workflow friction, bug reports, and integration ideas instead of scattering them across private messages.',
  changelog_2026_03_30_3: 'Feedback threads now support search, filtering, status labels, editing, and comments, so it is easier to see what is open, what is planned, and where other users are running into the same friction.',
  changelog_2026_03_30_4: 'Prompter, exports, and metadata review flows were also polished in this release, including better marketplace-focused keyword support and smaller usability fixes that smooth out everyday production work.',
  changelog_2026_03_29_1: 'The app shell and Metadata Studio were reorganized behind the scenes, so moving between pages, panels, and overlays feels more consistent and is less likely to break your flow during long sessions.',
  changelog_2026_03_29_2: 'Market Intelligence was expanded with a stronger Trends Radar and Similarity Scanner foundation, including richer dashboard blocks, deeper trend analysis, and a better base for insights, packs, and comparison workflows.',
  changelog_2026_03_29_3: 'Home, pricing, guest flows, alternatives, comparison pages, and blog surfaces were refreshed, making the product easier to understand before you create an account.',
  changelog_2026_03_29_4: 'Search and AI discovery coverage grew with refreshed sitemaps, feeds, llms assets, prerendering, and IndexNow support, helping new pages and guides appear faster across search and assistant-driven discovery.',
  changelog_2026_03_29_5: 'Account, BYOK, and history recovery flows were reconnected through safer server-backed reads, so profile data, previous exports, and recovery paths behave more reliably across sessions.',
  changelog_2026_03_28_1: 'List view now supports stronger multi-select and bulk edits, including visible/invert/unsaved filters plus one-click keyword, title, save, regenerate, and delete actions for selected files.',
  changelog_2026_03_28_2: 'Detail panel now includes Keyword Intelligence with marketability, title coverage, search-demand scoring, and one-click opportunity keyword suggestions to tighten metadata faster.',
  changelog_2026_03_28_3: 'Automatic metadata checks now flag required-field, keyword, category, and named commercial-rights issues directly in the workflow and recheck strong commercial blockers at export.',
  changelog_2026_03_28_4: 'Sessions no longer dead-end when credits, Free BYOK quota, or API access run out: waiting files pause safely, ready files stay exportable, and processing resumes after you add credits, paid access, or a key.',
  changelog_2026_03_28_5: 'Video files now show duration and estimated credit cost directly in the list and detail panels so you can plan generation before spending credits.',
  changelog_2026_03_28_6: 'Quick Actions search was added so you can jump to pages, settings, and workflow actions faster from one command palette.',
  changelog_2026_03_28_7: 'Free Credits and guest demo flows were expanded: users can share a referral link for extra credits, run a local browser demo, and preview sample CSV output before signing in.',
  changelog_2026_02_23_1: 'Mobile metadata editing was redesigned as a resizable bottom sheet so the list stays visible and users can quickly select the next file.',
  changelog_2026_02_23_2: 'Metadata panel now supports drag-to-expand and drag-to-collapse behavior with a compact list preview for faster mobile navigation.',
  changelog_2026_02_23_3: 'Fixed a ListView runtime crash caused by missing formatText reference to keep metadata sessions stable.',
  changelog_2026_02_23_4: 'Metadata generation now continues in the background while you navigate across pages, with completion notifications when processing ends.',
  changelog_2026_02_23_5: 'Prompter and Metadata Studio now share the same API queue; metadata keeps priority during active processing to prevent contention.',
  changelog_2026_02_23_6: 'Queue concurrency is now dynamic by plan/tier and API source (BYOK vs credits), preserving existing credit-based behavior.',
  changelog_2026_02_23_7: 'BYOK tier is auto-detected from OpenAI rate-limit headers and queue throughput updates live without restarting sessions.',
  changelog_2026_02_17_1: 'Performance improvements and bundle optimizations were applied to improve load speed and Core Web Vitals.',
  changelog_2026_02_16_1: 'Prompter added to Stocktag: a drag-and-drop workspace that turns reference images into structured, stock-ready prompts.',
  changelog_2026_02_16_2: 'Generation flow now supports Standard / Creative / Different mode combinations plus multi-variation batch outputs per file.',
  changelog_2026_02_16_3: 'Style Engine integrated end-to-end: Image Based, Selected Styles, All Styles, and Mixed mode with built-in and community style support.',
  changelog_2026_02_16_4: 'Workspace output experience improved with style-group headers and one-click copy directly on generated prompt text.',
  changelog_2026_02_16_5: 'Strict vector style enforcement added for restricted palettes (duotone/limited/monochrome), black-white override, and style-safe color control.',
  changelog_2026_02_16_6: 'Prompt-to-image pipeline connected to profile API keys with OpenAI/Gemini provider controls, model settings, and auto image generation queue.',
  changelog_2026_02_16_7: 'Stock Search + import and Community Styles workflows are included: search providers, create/edit/share styles, AI style extraction, and history restore.',
  changelog_2026_02_16_8: 'Prompter is fully visible for all users, but active generation/search/community write actions are locked for free/guest accounts and unlocked for subscribers.',
  changelog_2026_02_13_1: 'Trends Radar now supports keyword, region, timeframe, and side-by-side comparison queries',
  changelog_2026_02_13_2: 'Premium Radar added: stock-site SERP scan, stock saturation score, and blended score',
  changelog_2026_02_13_3: 'Added AI insights layer: breakout topics, action playbook, and risk notes',
  changelog_2026_02_13_4: 'Added Stocktag.AI Insights tables: monthly demand map with Live/Observed/Forecast modes',
  changelog_2026_02_13_5: 'Similarity Scanner (Beta) moved to a link-first flow with Adobe/Shutterstock URL scan and live progress streaming',
  changelog_2026_02_13_6: 'Added on-demand per-asset analysis with Exact-Like/Visual Match/AI Suggested classes and AI-assisted reranking',
  changelog_2026_02_09_1: 'Free BYOK flow is clearer',
  changelog_2026_02_09_2: 'Help Center content refreshed',
  changelog_2026_02_08_1: 'Video metadata processing is faster',
  changelog_2026_02_08_2: 'Unlimited BYOK usage experience improved',
  changelog_2026_02_08_3: 'General UI improvements shipped',
  changelog_2026_02_06_1: '9 new CSV formats added',
  changelog_2026_02_06_2: 'ZIP export missing files fixed',
  changelog_2026_02_05_1: 'New brand assets added',
  changelog_2026_02_05_2: 'Site content refreshed',
  changelog_2025_12_08_1: 'Subscription management and account view improved',
  changelog_2025_12_08_2: 'New pricing structure launched',
  changelog_2025_12_08_3: 'Credits display and low credit warnings added',
  changelog_2025_12_05_1: 'Shutterstock category export issue fixed',
  changelog_2025_12_05_2: 'Processing optimizations shipped',
  changelog_2025_11_25_1: 'Title/description/keyword quality improved',
  changelog_2025_11_25_2: 'Keyword slider (5-50) added',
  changelog_2025_11_25_3: 'Performance and speed improvements delivered',
  changelog_2025_11_20_1: 'Metadata editing and drafts improved',
  changelog_2025_11_20_2: 'Thumbnail and list view improved',
  changelog_2025_11_20_3: 'Marketplace rules refined',
  changelog_2025_11_19_1: 'Stability improvements shipped',
  changelog_2025_11_14_1: 'API key experience improved',
  changelog_2025_08_25_1: 'Deployment and configuration improvements',
  changelog_2025_08_25_2: 'Security enhancements delivered',
  changelog_2025_07_01_1: 'File management and archive flow enhanced',
  changelog_2025_06_28_1: 'Notification system refreshed',
  changelog_2025_06_28_2: 'Performance improvements delivered',
  changelog_2025_06_28_3: 'Credit operations stabilized',
  changelog_2025_06_26_1: 'Credits and metadata embedding improved',
  changelog_2025_06_26_2: 'Login security strengthened',
  changelog_2025_06_25_1: 'Payments and credit management improved',
  changelog_2025_06_25_2: 'Domain and publishing flow refined',
  changelog_2025_06_24_1: 'Metadata embedding and ZIP downloads added',
  changelog_2025_06_24_2: 'Top controls and download UX improved',
  changelog_2025_06_23_1: 'Folder isolation and live counters added',
  changelog_2025_06_23_2: 'Upload screen and flows refreshed',
  changelog_2025_04_19_1: 'Custom prompts and translation controls added',
  changelog_2025_04_19_2: 'Pagination and CSV exports expanded',
  changelog_2025_04_19_3: 'Gemini support and model options added',
  changelog_2025_02_08_1: 'Authentication flow and UI improved',
  changelog_2025_02_07_1: 'Login screens refreshed',
  changelog_2025_02_07_2: 'Initial release',
  help_changelog_more_title: 'Full history',
  help_changelog_more_body: 'See the complete list of commits and releases in GitHub.',
  help_changelog_more_cta: 'Open GitHub commit history',
  changelog_entry_a1672fe_title: 'Update free BYOK UX, gating, and help content',
  changelog_entry_a1672fe_body: 'Improved BYOK key handling, upload warnings, pricing CTAs, and help documentation.',
  changelog_entry_6ccf080_title: 'Secure BYOK storage and provider fixes',
  changelog_entry_6ccf080_body: 'Hardened API key storage and fixed provider handling.',
  changelog_entry_ae2b649_title: 'Route video files through video queue',
  changelog_entry_ae2b649_body: 'Improved video metadata processing reliability and sequencing.',
  changelog_entry_51de77a_title: 'Fix BYOK unlimited credits handling',
  changelog_entry_51de77a_body: 'Corrected Unlimited BYOK credit behavior and edge cases.',
  changelog_entry_9d8b876_title: 'Add guest trial rollback on failure',
  changelog_entry_9d8b876_body: 'Rolled back guest usage safely on failed operations.',
  changelog_entry_4e20e18_title: 'Refresh content, tooling, and build output',
  changelog_entry_4e20e18_body: 'Updated marketing content, tooling, and build assets.',
  changelog_entry_c75c641_title: 'Add 9 new CSV formats + ZIP export fix',
  changelog_entry_c75c641_body: 'Expanded marketplace exports and fixed missing ZIP files.',
  changelog_entry_aa51398_title: 'Fix subscription sync and management URLs',
  changelog_entry_aa51398_body: 'Improved Paddle sync and customer portal handling.',
  changelog_entry_3bfc10c_title: 'Add new pricing structure',
  changelog_entry_3bfc10c_body: 'Updated plans and pricing tiers.',
  changelog_entry_8972f34_title: 'Add credit display, low credit banner, and shortcuts',
  changelog_entry_8972f34_body: 'Improved credit visibility and productivity controls.',
  help_title: 'Learn Stocktag',
  help_subtitle: 'Clear guides to Metadata Studio, exports, market tools, and image generation.',
  help_overview_title: 'Quick overview',
  help_overview_item_1: 'Drop assets and generate metadata in minutes.',
  help_overview_item_2: 'Review, edit, and regenerate with AI.',
  help_overview_item_3: 'Export CSVs or embed metadata before upload.',
  help_quick_start_title: 'Quick start',
  help_quick_start_body: 'Upload a file and create publish-ready metadata in a few steps.',
  help_quick_drop_title: 'Drop assets',
  help_quick_drop_body: 'Drag images, vectors, or videos into the studio to start processing.',
  help_quick_drop_alt: 'File upload area screenshot',
  help_quick_review_title: 'Review and refine',
  help_quick_review_body: 'Edit titles, descriptions, and keywords with quick actions and AI refinements.',
  help_quick_review_alt: 'Metadata review panel screenshot',
  help_quick_export_title: 'Export and publish',
  help_quick_export_body: 'Download CSVs or embed metadata into files before uploading.',
  help_quick_export_alt: 'Export panel screenshot',
  help_core_features_title: 'Core features',
  help_core_features_body: 'Practical tools for every stage of a stock portfolio.',
  help_feature_dual_ai_title: 'Dual AI engine',
  help_feature_dual_ai_body: 'Hybrid vision + language models tuned for stock-ready metadata.',
  help_feature_batch_title: 'Batch processing',
  help_feature_batch_body: 'Handle large groups of files with batch processing and ready-made settings.',
  help_feature_keywords_title: 'Precision keywords',
  help_feature_keywords_body: 'Create clear titles, descriptions, and keyword sets quickly.',
  help_feature_exports_title: 'Instant exports',
  help_feature_exports_body: 'Download CSV files or embed metadata in the same workflow.',
  help_feature_shortcuts_title: 'Studio shortcuts',
  help_feature_shortcuts_body: 'Keyboard-first controls designed for speed and focus.',
  help_feature_safe_title: 'Safe by design',
  help_feature_safe_body: 'Drafts, undo history, and controlled edits before export.',
  help_studio_modules_title: 'Metadata Studio modules',
  help_studio_modules_body: 'Every control in the studio, explained one by one.',
  help_module_metadata_controls_title: 'Metadata controls',
  help_module_metadata_controls_body: 'Set title and description lengths, keyword rules, and marketplace formats.',
  help_module_art_style_title: 'Art style detection',
  help_module_art_style_body: 'Surface style tags with optional deep analysis mode.',
  help_module_png_vector_title: 'PNG + vector modes',
  help_module_png_vector_body: 'Choose dedicated modes for transparent images and illustrations.',
  help_module_history_title: 'History and drafts',
  help_module_history_body: 'Keep session history, restore drafts, and stay consistent.',
  help_module_exports_title: 'CSV + embedded export',
  help_module_exports_body: 'Export CSVs or embed metadata into files before upload.',
  help_module_byok_title: 'Unlimited BYOK ready',
  help_module_byok_body: 'Connect your own API keys to remove daily limits and scale up.',
  help_vi_title: 'Visual intelligence',
  help_vi_body: 'Advanced AI features for deeper, cleaner metadata output.',
  help_vi_reasoning: 'Reasoning mode that explains why tags are suggested.',
  help_vi_png_vector: 'PNG + vector modes for transparent assets and illustrations.',
  help_vi_video: 'Video metadata samples 1 frame per second and charges 1 credit per 5 seconds of video.',
  help_vi_regenerate: 'Regenerate and refine titles or keywords with one click.',
  help_vi_export: 'Choose exactly which CSV formats to output every session.',
  help_vi_safe: 'Drafts and undo history keep edits controlled.',
  help_platforms_title: 'Marketplace settings',
  help_platforms_body: 'Prepare metadata around each marketplace\'s requirements.',
  help_platform_adobe_title: 'Adobe Stock',
  help_platform_adobe_body: 'Top keywords surfaced first to match Adobe ordering.',
  help_platform_shutterstock_title: 'Shutterstock',
  help_platform_shutterstock_body: 'Keyword count checks and relevance cleanup for approvals.',
  help_platform_creative_fabrica_title: 'Creative Fabrica',
  help_platform_creative_fabrica_body: 'SEO-forward formatting for craft marketplaces.',
  help_platform_design_bundles_title: 'Design Bundles',
  help_platform_design_bundles_body: 'Structured tag sets that match marketplace expectations.',
  help_mi_title: 'Market Intelligence',
  help_mi_body: 'See demand and trends, then plan what to create with more confidence.',
  help_mi_calendar: 'Holiday and seasonal calendar for planning content.',
  help_mi_trends: 'Trend-driven keyword packs for stock search demand.',
  help_mi_regions: 'Regional market signals to match local demand.',
  help_mi_timing: 'Plan the right publishing window before demand rises.',
  help_ig_title: 'Image Generator',
  help_ig_body: 'Create images suited to stock use, then prepare their metadata.',
  help_ig_generation: 'Create images suited to stock use from a written prompt.',
  help_ig_controls: 'Choose model, aspect ratio, and output format.',
  help_ig_style: 'Control backgrounds, style, and quality for marketplaces.',
  help_ig_workflow: 'Generate, tag, and export in one workflow.',
  help_screenshots_title: 'Screenshots',
  help_screenshots_body: 'Follow the flow below to see how the app works end to end.',
  help_shot_studio_title: 'Studio overview',
  help_shot_studio_body: 'Upload your files and start creating metadata.',
  help_shot_studio_alt: 'Metadata studio overview screenshot',
  help_shot_settings_title: 'Metadata settings',
  help_shot_settings_body: 'Control lengths, rules, and platform presets.',
  help_shot_settings_alt: 'Metadata settings panel screenshot',
  help_shot_review_title: 'Review and edit',
  help_shot_review_body: 'Use quick edits, AI refinements, and undo history.',
  help_shot_review_alt: 'Review and edit panel screenshot',
  help_shot_export_title: 'Export options',
  help_shot_export_body: 'Download CSVs or embed metadata into files.',
  help_shot_export_alt: 'Export options screenshot',
  help_faq_title: 'FAQ',
  help_faq_body: 'Browse guides, common questions, and the latest product updates.',
  help_faq_formats_q: 'Which file types are supported?',
  help_faq_formats_a: 'JPG, PNG, SVG, EPS, MP4, and MOV are supported in the studio.',
  help_faq_byok_q: 'What is BYOK and why use it?',
  help_faq_byok_a: 'Bring your own API keys to control provider usage. Free BYOK has a daily allowance; Unlimited BYOK removes the Stocktag daily cap.',
  help_faq_exports_q: 'Can I export multiple marketplaces at once?',
  help_faq_exports_a: 'Yes. Enable the formats you need, then export a ZIP with all CSVs.',
  help_faq_translation_q: 'Can I translate metadata to another language?',
  help_faq_translation_a: 'Enable auto-translate and choose a target language in Metadata settings.',
  help_profile_title: 'User profile',
  help_profile_body: 'A detailed walkthrough of every area in the profile panel, what each card shows, and which actions it triggers.',
  help_profile_account_title: 'Account and plan',
  help_profile_account_body: 'See your email, plan, and account status at a glance. This confirms your active plan and account identity.',
  help_profile_credits_title: 'Credits and usage',
  help_profile_credits_body: 'Track remaining credits and open the purchase flow when you need more. Use this to monitor usage and avoid interruptions.',
  help_profile_theme_title: 'Theme settings',
  help_profile_theme_body: 'Switch themes to match your workspace lighting and preference. Theme changes affect contrast and readability.',
  help_profile_api_keys_title: 'API keys (BYOK)',
  help_profile_api_keys_body: 'Add OpenAI, Gemini, Claude, Groq, or Grok keys to unlock BYOK and control usage. Free BYOK has a daily allowance; Unlimited BYOK removes the Stocktag daily cap.',
  help_profile_billing_title: 'Billing and upgrades',
  help_profile_billing_body: 'Upgrade plans or purchase credits directly from the profile panel. Manage billing and unlock higher limits here.',
  help_profile_security_title: 'Security and sign out',
  help_profile_security_body: 'Sign out when you are done to keep your session secure, especially on shared devices.',
  help_metadata_details_title: 'Metadata tab: detailed controls',
  help_metadata_details_body: 'Every switch and field in the Metadata panel, what it changes, and when to use it for consistent output.',
  help_metadata_workflow_title: 'Workflow settings',
  help_metadata_workflow_body: 'Auto-start processing, control session behavior, and decide when generation begins. Choose whether processing starts immediately or after you review settings.',
  help_metadata_title_settings_title: 'Title settings',
  help_metadata_title_settings_body: 'Set title length, apply capitalization rules, and add optional prefixes or suffixes to keep naming consistent.',
  help_metadata_description_settings_title: 'Description settings',
  help_metadata_description_settings_body: 'Define description length and keep outputs consistent across assets and marketplaces.',
  help_metadata_keyword_rules_title: 'Keyword rules',
  help_metadata_keyword_rules_body: 'Choose keyword count, single or mixed rules, and ordering preferences to optimize search relevance.',
  help_metadata_custom_instructions_title: 'Custom instructions',
  help_metadata_custom_instructions_body: 'Add global instructions that the AI must follow for every file, such as brand tone or mandatory terms.',
  help_metadata_prohibited_words_title: 'Prohibited words',
  help_metadata_prohibited_words_body: 'Block unwanted words or phrases from appearing in outputs to stay compliant and clean.',
  help_metadata_translation_title: 'Translation',
  help_metadata_translation_body: 'Enable auto-translate and choose a target language for outputs across the entire session.',
  help_metadata_modes_title: 'PNG, vector, and EPS modes',
  help_metadata_modes_body: 'Toggle transparent asset modes and EPS workflows for correct metadata handling per file type.',
  help_metadata_ai_features_title: 'AI features',
  help_metadata_ai_features_body: 'Enable art style detection or deeper reasoning for richer, more descriptive metadata. In credit-based plans, deep analysis uses 2x credits.',
  help_metadata_export_formats_title: 'Export formats',
  help_metadata_export_formats_body: 'Select marketplace CSV formats and export preferences per session, generating multiple outputs at once.',
  help_history_title: 'History tab: exports and drafts',
  help_history_body: 'Find past exports, recover drafts, and manage stored CSVs. This is your archive for previous sessions.',
  help_history_search_title: 'Search and filter',
  help_history_search_body: 'Search by filename to quickly find a past export in large projects.',
  help_history_download_title: 'Download exports',
  help_history_download_body: 'Click a history item to download its CSV again for sharing or backup.',
  help_history_drafts_title: 'Last work',
  help_history_drafts_body: 'Your latest unfinished work is kept as one item. Prepare or re-download its normal CSV ZIP without creating duplicate recovery entries.',
  help_history_bulk_title: 'Bulk actions',
  help_history_bulk_body: 'Select multiple items to delete in one action and keep history clean.',
  help_history_expiration_title: 'Expiration info',
  help_history_expiration_body: 'See how long each export remains available so you can download before it expires.',
  help_history_status_title: 'Status and errors',
  help_history_status_body: 'Loading and error states show when history is still syncing or unavailable.',
  help_profile_shot_overview_title: 'Profile overview',
  help_profile_shot_overview_body: 'Account, plan, and credits summary at the top.',
  help_profile_shot_overview_alt: 'User profile overview screenshot',
  help_profile_shot_keys_title: 'API keys section',
  help_profile_shot_keys_body: 'Add and manage BYOK keys and usage preferences.',
  help_profile_shot_keys_alt: "Capture of the API keys section",
  help_profile_shot_theme_title: "Theme and preferences",
  help_profile_shot_theme_body: "Change your theme and customize your workspace.",

  panel_user_profile: "User Profile",
  account_settings_title: "Account & Settings",
  settings_tab_account: "Account",
  settings_tab_api_keys: "API Keys",
  settings_tab_preferences: "Preferences",
  settings_tab_subscription: "Plan & Billing",
  settings_shortcuts_title: "Settings shortcuts",
  settings_keys_connected: "{count} connected",
  settings_keys_empty: "No API key connected",
  settings_preferences_desc: "Theme, newsletter and privacy",
  settings_subscription_desc: "Plan details and purchase history",
  // Account deletion (self-service): Danger zone card only. The dialog and
  // lock-screen copy loads on demand from ./accountDeletion/ (see
  // ./accountDeletionCopy.js).
  account_delete_zone_title: "Danger zone",
  account_delete_zone_body: "Permanently delete your account and data. You’ll have 14 days to change your mind.",
  account_delete_open_button: "Delete account…",
  account_delete_admin_note: "Admin accounts cannot be deleted here.",
  user_profile_credits: "credits",
  buy_credits: "+ Buy",
  subscription: "Subscription",
  credit_access_title: "Credit access",
  credit_access_paid_badge: "Paid access",
  credit_access_ready: "Ready to use",
  credit_access_refill_needed: "Top-up needed",
  credit_access_description: "Use built-in AI with prepaid credits. No subscription or API key is required.",
  credit_access_balance: "Available credits",
  credit_access_billing: "Billing",
  credit_access_no_renewal: "No automatic renewal",
  credit_access_benefits: "Included with credit access",
  credit_access_no_key: "Built-in AI — no API key needed",
  credit_access_no_expiry: "Purchased credits never expire",
  credit_access_topup_anytime: "Top up whenever you need",
  credit_access_empty_note: "Your credit-member status stays with your account. Top up to keep using built-in AI.",
  credit_access_topup_cta: "Top up credits",
  access_type: "Access:",
  plan: "Plan:",
  plan_addon: "Add-on:",
  status: "Status:",
  manage: "Manage",
  purchase_history_title: "Purchase History",
  purchase_history_empty: "No purchases yet.",
  purchase_type_credit_pack: "Credit Pack",
  purchase_type_subscription: "Subscription",
  purchase_type_purchase: "Purchase",
  appearance: "Appearance",
  api_keys_section_title: "API Keys",
  api_keys_helper_1: "Add your keys for OpenAI, Gemini, Claude, Groq, or Grok. Free BYOK starts at most one request every {seconds} seconds and includes 100/day; Unlimited BYOK removes Stocktag's pacing and daily cap.",
  api_keys_helper_2: "Your API keys are stored securely and never shown. They are encrypted and used only to run your requests.",
  prefer_credits_checkbox: "Prefer using credits when available (falls back to your API key when credits run out).",
  default_model_title: "Default Model",
  default_model_caption: "Used for all BYOK requests. Leave model blank to auto-select.",
  provider_label: "Provider",
  model_id_label: "Model ID",
  model_tip: "Tip: You can paste any model ID even if it’s not in the list.",
  get_key: "Get key",
  openai_caption: "GPT-4.1, GPT-5 mini",
  gemini_caption: "Gemini 3.5 Flash / 3.1 Flash-Lite",
  anthropic_caption: "Claude Opus 5.5, Sonnet 5.5, Haiku 5.5",
  groq_caption: "Llama 3.2 Vision",
  xai_caption: "Grok 2 Vision",
  gemini_free_tier_warning: "Gemini Free Tier (AIza...) has a limit of ~20 files/day.",
  social_twitter: "Twitter",
  social_instagram: "Instagram",
  sign_out: "Sign Out",
  save: "Save",
  status_active: "Active",
  syncing_subscription: "Syncing subscription...",
  unlimited: "Unlimited",
  theme_light: "Light",
  theme_dark: "Dark",
  theme_true_dark: "True Dark",
  theme_neon: "Neon",
  masked_key_text: "•••••••• (Saved securely, not visible)",
  provider_openai: "OpenAI (GPT)",
  provider_gemini: "Google Gemini",
  provider_anthropic: "Anthropic (Claude)",
  provider_groq: "Groq",
  provider_xai: "xAI (Grok)",
  api_key_saved: "API key saved successfully.",
  api_key_removed: "API key removed.",
  action_failed: "Action failed. Please try again.",
  invalid_openai_key: "Invalid OpenAI key",
  invalid_gemini_key: "Invalid Gemini key",
  invalid_anthropic_key: "Invalid Anthropic key",
  invalid_groq_key: "Invalid Groq key",
  invalid_xai_key: "Invalid xAI key",
  operation_failed: "Operation failed.",
  gemini_key_saved: "Gemini API key saved.",
  anthropic_key_saved: "Anthropic API key saved.",
  groq_key_saved: "Groq API key saved.",
  xai_key_saved: "xAI API key saved.",
  close_panel: "Close panel",
  byok_reasoning_warning_title: "Reasoning model required",
  byok_reasoning_warning_body: "Please choose a reasoning model or disable Deep Analysis.",
  byok_reasoning_action_model: "Select GPT-5 mini",
  byok_reasoning_action_disable: "Disable Deep Analysis",
  openai_no_reasoning_tag: "No reasoning",
  openai_model_no_reasoning_hint: "This model does not support reasoning. While it is selected, Standard and Deep Analysis run without reasoning.",
  help_profile_shot_theme_alt: 'Theme selection screenshot',
  help_metadata_shot_workflow_title: 'Workflow controls',
  help_metadata_shot_workflow_body: 'Auto-start, session flow, and generation controls.',
  help_metadata_shot_workflow_alt: 'Metadata workflow controls screenshot',
  help_metadata_shot_title_desc_title: 'Title and description settings',
  help_metadata_shot_title_desc_body: 'Length, capitalization, prefix, and postfix options.',
  help_metadata_shot_title_desc_alt: 'Title and description settings screenshot',
  help_metadata_shot_keywords_title: 'Keyword rules',
  help_metadata_shot_keywords_body: 'Keyword count, single or mixed rules, and ordering.',
  help_metadata_shot_keywords_alt: 'Keyword rules screenshot',
  help_metadata_shot_advanced_title: 'Advanced controls',
  help_metadata_shot_advanced_body: 'Prohibited words, custom instructions, and AI features.',
  help_metadata_shot_advanced_alt: 'Advanced metadata controls screenshot',
  help_metadata_shot_export_title: 'Export formats',
  help_metadata_shot_export_body: 'Marketplace CSV selection and export preferences.',
  help_metadata_shot_export_alt: 'Export formats screenshot',
  help_history_shot_list_title: 'History list',
  help_history_shot_list_body: 'Search, filter, and open past exports.',
  help_history_shot_list_alt: 'History list screenshot',
  help_history_shot_drafts_title: 'Last work',
  help_history_shot_drafts_body: 'Prepare or download the latest work as a normal CSV ZIP.',
  help_history_shot_drafts_alt: 'Draft recovery screenshot',
  help_history_shot_bulk_title: 'Bulk actions',
  help_history_shot_bulk_body: 'Select multiple items to delete at once.',
  help_history_shot_bulk_alt: 'Bulk actions screenshot',
  help_profile_media_title: 'Profile walkthrough',
  help_profile_media_body: 'Watch how to review plan details, credits, and API keys step by step.',
  help_metadata_media_title: 'Metadata settings walkthrough',
  help_metadata_media_body: 'See how each control changes the output for titles, keywords, and exports.',
  help_history_media_title: 'History recovery walkthrough',
  help_history_media_body: 'Learn how to find exports, restore drafts, and manage downloads in one flow.',
  qa_strip_title: 'Export Check',
  qa_strip_status_ready: 'Ready to export',
  qa_strip_status_blocked: 'Export blocked',
  qa_strip_status_ready_desc: 'This checks missing fields, category gaps, keyword quality, and release or trademark risk before export.',
  qa_strip_status_blocked_desc: 'This stops CSV or embedded export when files still have required-field or platform-rule blockers.',
  qa_strip_blockers: '{count} blockers',
  qa_strip_warnings: '{count} warnings',
  qa_strip_score: 'Score {score}',
  qa_strip_review_issues: 'Review issues',
  qa_strip_view_checks: 'View checks',
  qa_modal_badge: 'Export Check',
  qa_modal_title: 'Why this exists',
  qa_modal_intro: 'It catches metadata issues before export so fewer files get rejected and you spend less time cleaning CSVs manually.',
  qa_modal_required_title: 'Required fields',
  qa_modal_required_body: 'Checks title, description, keywords, and required marketplace categories.',
  qa_modal_quality_title: 'Quality cleanup',
  qa_modal_quality_body: 'Flags duplicate keywords, weak filler terms, and title formatting problems.',
  qa_modal_compliance_title: 'Compliance hints',
  qa_modal_compliance_body: 'Warns on trademark, logo, people, property, and release-related signals.',
  qa_modal_average_score: 'Average score',
  qa_modal_ready_files: 'Ready files',
  qa_modal_blocking_files: 'Blocking files',
  qa_modal_release_checks: 'Release checks',
  qa_modal_ready_banner: 'Export is clear. There are still {warnings} warning(s) and {infos} reminder(s) you may want to review.',
  qa_modal_blocked_banner: 'Export is currently blocked. {files} file(s) still have {issues} blocker(s).',
  qa_modal_progress_title: 'Readiness',
  qa_modal_progress_body: '{ready} of {total} files are currently clear for export.',
  qa_modal_blocking_files_short: '{count} blocked',
  qa_modal_no_blockers: 'No blockers',
  qa_modal_priority_title: 'Next steps',
  qa_modal_step_blockers_title: 'Fix blockers first',
  qa_modal_step_blockers_body: '{count} file(s) still stop export. Start with the highest-risk rows below.',
  qa_modal_step_warnings_title: 'Review warning-heavy files',
  qa_modal_step_warnings_body: '{count} warning(s) remain. Clean them up before final delivery if approvals are strict.',
  qa_modal_step_release_title: 'Check release-sensitive items',
  qa_modal_step_release_body: '{count} file(s) show trademark, logo, people, or property signals worth a final pass.',
  qa_modal_step_ready_title: 'Export can go ahead',
  qa_modal_step_ready_body: 'No blockers remain. Use the file list below only for a last spot-check.',
  qa_modal_start_here: 'Start here',
  qa_modal_start_placeholder: 'Open this file first.',
  qa_modal_open_file: 'Open file',
  qa_modal_risks_title: 'Highest-risk files',
  qa_modal_risks_body: 'Open a file to see its blockers and fix them from the detail panel.',
  qa_modal_close: 'Close export check',
  qa_platform_main_export: 'Main metadata export',
  qa_ready_for_export: 'Ready for export.',
  qa_issue_label_blocker: 'Blocker',
  qa_issue_label_warning: 'Warning',
  qa_issue_label_check: 'Check',
  qa_detail_title: 'Export Check',
  qa_detail_ready_body: 'No blocking issues detected for this file.',
  qa_detail_blocked_body: '{count} blocking issue(s) need attention before export.',
  qa_detail_score: 'Score {score}',
  qa_detail_ready_pill: 'Ready',
  qa_detail_blockers: '{count} blockers',
  qa_detail_warnings: '{count} warnings',
  qa_detail_checks: '{count} checks',
  qa_toast_export_blocked: 'Export Check blocked {target}. {files} file(s) still have {issues} blocking issue(s).',
  qa_toast_commercial_rights_blocked: 'Commercial export blocked for {file}: high-confidence protected content or metadata requires review{terms}. Remove or replace the term, clear the rights issue, or use editorial mode when appropriate.',
  qa_toast_commercial_rights_export_continues: 'Commercial rights warning for {file}{terms}. Export will continue; review licensing eligibility before submission.',
  qa_toast_commercial_rights_selected_item: 'the selected item',
  qa_target_csv_export: 'CSV export',
  qa_target_embedded_export: 'embedded image export',
  qa_issue_missing_title: 'Title is required before export.',
  qa_issue_missing_description: 'Description is required before export.',
  qa_issue_missing_keywords: 'Add keywords before export.',
  qa_issue_title_keyword_string: 'Title looks comma-separated. Rewrite it as a descriptive sentence.',
  qa_issue_short_description: 'Description is very short. Add more context if approvals are sensitive.',
  qa_issue_duplicate_keywords: 'Duplicate keywords detected: {keywords}.',
  qa_issue_weak_keywords: 'Weak or filler keywords detected: {keywords}.',
  qa_issue_missing_adobe_category: 'Adobe Stock export is enabled but Adobe category is empty.',
  qa_issue_missing_shutterstock_category: 'Shutterstock export is enabled but Shutterstock category is empty.',
  qa_issue_shutterstock_keyword_range: 'Shutterstock expects 7-50 keywords. Current count: {count}.',
  qa_issue_shutterstock_title_length: 'Shutterstock title is over 200 characters ({count}).',
  qa_issue_shutterstock_description_length: 'Shutterstock description is over 200 characters ({count}).',
  qa_issue_shutterstock_title_too_short: 'Shutterstock titles perform better as descriptive phrases with at least 5 words.',
  qa_issue_adobe_top10_short: 'Adobe Stock gives extra weight to the first 10 keywords. Consider expanding beyond 10 strong terms.',
  qa_issue_adobe_title_keyword_alignment: 'Adobe title terms are not reflected in the first 10 keywords. Align core terms for stronger ordering.',
  qa_issue_cf_title_too_long: 'Creative Fabrica title is over 40 characters ({count}).',
  qa_issue_cf_title_too_short: 'Creative Fabrica titles work better around 20-40 characters. Current length: {count}.',
  qa_issue_cf_keyword_range: 'Creative Fabrica keyword target is 35-40. Current count: {count}.',
  qa_issue_db_title_too_long: 'Design Bundles title is over 60 characters ({count}).',
  qa_issue_db_title_too_short: 'Design Bundles titles work better around 40-60 characters. Current length: {count}.',
  qa_issue_db_keyword_count: 'Design Bundles keyword target is exactly 10. Current count: {count}.',
  qa_issue_trademark_risk: 'Possible brand or trademark terms detected: {terms}.',
  qa_issue_logo_visibility: 'Logo-related language detected. Confirm logos are removed or that the content is suitable for editorial use.',
  qa_issue_visual_ip_risk: 'The visual may contain protected intellectual property: {terms}. Review before commercial licensing.',
  qa_issue_visual_ip_risk_generic: 'The visual may contain protected intellectual property. Review before commercial licensing.',
  qa_issue_commercial_metadata_policy_blocker: 'Protected commercial metadata term “{term}” was detected in {fields}. Remove or replace it before export.{replacement}',
  qa_issue_commercial_metadata_policy_review: 'Commercial metadata term “{term}” needs rights review in {fields}.{replacement}',
  qa_issue_commercial_metadata_replacement: ' Suggested generic replacement: “{replacement}”.',
  qa_issue_commercial_metadata_generic_field: 'metadata',
  qa_issue_model_release_check: 'People-related terms detected. Confirm model release needs before commercial export.',
  qa_issue_property_release_check: 'Property/interior terms detected. Confirm property release or editorial eligibility if needed.',
  ip_warning_badge: 'Rights review',
  ip_warning_metadata_badge: 'Metadata review',
  ip_warning_unavailable_badge: 'Check unavailable',
  ip_warning_title: 'Possible protected content',
  ip_warning_metadata_title: 'Possible protected commercial metadata',
  ip_warning_combined_title: 'Possible visual and metadata rights risks',
  ip_warning_unavailable_title: 'Rights verification unavailable',
  ip_warning_unavailable_summary: 'The canonical identity service could not complete this check. No clear decision was recorded; retry before commercial licensing.',
  ip_warning_metadata_unavailable_summary: 'Commercial metadata contains terms that need removal or rights review: {terms}. The visual identity check was unavailable and should be retried.',
  ip_warning_metadata_summary: 'Commercial metadata contains protected or restricted terms: {terms}. Remove, replace, or clear the terms before commercial export.',
  ip_warning_combined_summary: 'Review the protected visual signals and these commercial metadata terms before licensing: {terms}.',
  ip_warning_metadata_terms_generic: 'flagged terms',
  ip_warning_summary_terms: 'Review these visible elements before commercial licensing: {terms}.',
  ip_warning_summary_fallback: 'The visual may contain intellectual property that needs review before commercial licensing.',
  ip_warning_level_high: 'Strong visual identity match',
  ip_warning_level_review: 'Possible visual identity match',
  ip_warning_level_combined_high: 'High-confidence rights signals',
  ip_warning_level_combined_review: 'Visual + metadata review',
  ip_warning_level_metadata_high: 'High-confidence metadata term',
  ip_warning_level_metadata_review: 'Metadata term review',
  ip_warning_level_unavailable: 'No decision',
  ip_warning_identity_confidence: '{confidence}% identity match',
  ip_warning_visible_signals: 'Visible signals: {signals}',
  ip_observed_identity_title: 'AI observed a possible visible identity',
  ip_observed_identity_metadata_title: 'Preliminary visual identity and metadata review',
  ip_observed_identity_summary: 'The metadata model observed a high-confidence visible name or unmistakable logo candidate: {terms}. This preliminary signal is not dual-layer verification and does not prove ownership or infringement.',
  ip_observed_identity_badge: 'AI identity candidate',
  ip_observed_identity_level: 'Preliminary AI observation',
  ip_observed_identity_confidence: '{confidence}% preliminary confidence',
  ip_observed_identity_visible_text: 'Visible text: “{text}”.',
  ip_observed_identity_catalog_match: 'The name also matches the local commercial identity rules as {identity}; review it before commercial licensing.',
  ip_observed_identity_unverified: 'No local catalog match was used to verify this observation; inspect the visual manually.',
  ip_warning_metadata_confidence: '{confidence}% metadata term confidence',
  ip_warning_metadata_matched_term: 'Matched metadata term: “{term}”.',
  ip_warning_metadata_fields: 'Metadata fields: {fields}.',
  ip_warning_metadata_replacement: 'Suggested generic replacement: “{replacement}”.',
  ip_warning_canonical_sources: 'Canonical identity matches',
  ip_warning_canonical_scope: 'Wikidata corroborates that the named entity exists; it does not verify registration, ownership, copyright status, or infringement.',
  ip_warning_official_sources: 'Official research sources',
  ip_warning_source_scope: 'Reference links support manual clearance research; they do not claim that an automatic registry match or legal determination was made.',
  ip_warning_disclaimer: 'This is an automated visual signal, not a legal determination. Verify licenses, releases, and marketplace rules.',
  ip_warning_metadata_disclaimer: 'These are automated visual and/or metadata policy signals, not a legal determination. Verify rights, metadata wording, and marketplace rules.',
  ip_clear_badge: 'Rights check clear',
  ip_clear_title: 'Commercial rights check clear',
  ip_clear_summary: 'Both visual identity checks completed without a protected-content match above the review threshold.',
  ip_clear_level: 'No match found',
  keyword_intel_title: 'Keyword Intelligence',
  keyword_intel_explainer: 'Blends title clarity, keyword diversity, weak-tag penalties, and Google + stock-site demand when available.',
  keyword_intel_marketability: 'Marketability',
  keyword_intel_weights: 'Weights: Title 45% · Keywords 35% · Description 20%',
  keyword_intel_title_score: 'Title',
  keyword_intel_keywords_score: 'Keywords',
  keyword_intel_demand_score: 'Search Demand',
  keyword_intel_live_checked: '{count} live-checked',
  keyword_intel_live_syncing: 'Syncing live',
  keyword_intel_local_model: 'Local model',
  keyword_intel_demand_live_note: 'Google + stock demand',
  keyword_intel_demand_local_note: 'Local estimate',
  keyword_intel_title_coverage: '{count}/{total} strong terms covered',
  keyword_intel_title_needs_input: 'Add title terms to improve coverage',
  keyword_intel_keyword_note: '{high} strong • {weak} weak',
  keyword_intel_stat_strong: '{count} strong',
  keyword_intel_stat_weak: '{count} weak',
  keyword_intel_stat_generic: '{count} generic',
  keyword_intel_tip_label: 'Tip:',
  keyword_intel_frontload: 'Front-load: {terms}',
  keyword_intel_title_good: 'Title already covers the strongest terms.',
  keyword_intel_opportunities: 'Opportunity keywords',
  keyword_intel_optional: 'Optional',
  keyword_intel_more: 'More',
  keyword_intel_less: 'Less',
  keyword_intel_chip_score: 'Score {score}',
  keyword_intel_chip_live: 'Live demand {score}',
  keyword_intel_reason_title_match: 'Strong title match',
  keyword_intel_reason_description_match: 'Connected to the description',
  keyword_intel_reason_weak_relevance: 'Weak match to visible metadata',
  keyword_intel_reason_strong_phrase: 'Specific 2-word phrase',
  keyword_intel_reason_long_tail: 'Useful long-tail phrase',
  keyword_intel_reason_too_long: 'Phrase is too long and diluted',
  keyword_intel_reason_generic: 'Too generic',
  keyword_intel_reason_weak: 'Too weak on its own',
  keyword_intel_reason_duplicate: 'Overlaps another keyword',
  keyword_intel_reason_top10: 'Strong placement in the top 10',
  keyword_intel_reason_late: 'Late in the keyword order',
  keyword_intel_reason_commercial: 'Has commercial or use-case value',
  keyword_intel_reason_live_hot: 'Live demand looks strong',
  keyword_intel_reason_live_crowded: 'Live demand is strong but crowded',
  keyword_intel_reason_live_niche: 'Live demand looks niche',
  meta_csv_getty_single_pass_note: 'Getty/iStock only: 1 AI request and no extra Getty/iStock credit (2 credits with Standard analysis).',
  meta_csv_getty_credit_warning: 'Getty/iStock + another metadata export: a second AI request adds 1 credit per file (3 credits with Standard analysis).',

  // Purchase success experience
  purchase_success_plan_fallback: 'Premium',
  purchase_delayed_title: 'Activation is taking a little longer',
  purchase_pending_title: 'Preparing your access',
  purchase_success_topup_title: 'Your credits are ready',
  purchase_success_byok_title: 'Unlimited is unlocked',
  purchase_success_subscription_title: '{plan} is active',
  purchase_delayed_body: 'Your payment is secure. Access verification is taking longer than usual, so please do not pay again. We will keep syncing in the background.',
  purchase_pending_body: 'Payment received. We are confirming your purchase with Paddle and activating it on your account.',
  purchase_success_topup_body: '{credits} credits were added and are ready for your next batch.',
  purchase_success_topup_body_generic: 'Your purchased credits were added to your account and are ready to use.',
  purchase_topup_plan_preserved_title: 'Your current access stays active',
  purchase_topup_plan_preserved_body: 'Extra credits were added separately. They do not replace your current plan and do not expire.',
  purchase_success_byok_body: 'Your Unlimited BYOK workspace is active. Connect your provider keys and create without Stocktag daily caps.',
  purchase_success_subscription_body: 'Your plan and included credits are active. Everything is ready for your next upload.',
  purchase_billing_yearly: 'Yearly billing',
  purchase_billing_monthly: 'Monthly billing',
  purchase_billing_onetime: 'One-time purchase',
  purchase_metric_credits: 'Credits',
  purchase_metric_unlimited: 'Unlimited',
  purchase_metric_credits_added: 'Credits added',
  purchase_metric_byok_access: 'BYOK access',
  purchase_metric_active_plan: 'Active plan',
  purchase_metric_credits_period: '{credits} credits per allocation',
  purchase_metric_credits_month: '{credits} credits per month',
  purchase_action_add_key: 'Set up API keys',
  purchase_action_view_queue: 'View your workspace',
  purchase_action_start_creating: 'Start creating',
  purchase_action_close: 'Close purchase confirmation',
  purchase_success_eyebrow: 'Access verified',
  purchase_pending_eyebrow: 'Payment received',
  purchase_status_active: 'Purchase active and ready to use.',
  purchase_status_delayed: 'Payment secured; activation is still syncing.',
  purchase_status_verifying: 'Securely verifying your access…',
  purchase_summary_label: 'Purchase summary',
  purchase_payment_confirmed: 'Payment confirmed',
  purchase_access_active_now: 'Active now',
  purchase_access_processing: 'Activating',
  purchase_access_server_verified: 'Server-verified access',
  purchase_receipt_email: 'Receipt sent to {email}',
  purchase_copy_confirmation: 'Copy confirmation number',
  purchase_confirmation_label: 'Confirmation',
  purchase_confirmation_copied: 'Confirmation number copied',
  purchase_action_details: 'Plan & purchase details',
  purchase_action_continue_background: 'Continue while this finishes',
  purchase_trust_verified: 'Payment and access verified securely',
  purchase_trust_paddle: 'Secure payment processing by Paddle',
  newsletter_signup_consent: 'I want to receive weekly Stocktag tips, product news, and offers by email. Optional; unsubscribe anytime.',
  newsletter_consent_prompt_title: 'Get the useful Stocktag weekly email?',
  newsletter_consent_prompt_body: 'Receive practical metadata tips, product news, and occasional offers. This is optional and you can unsubscribe at any time.',
  newsletter_consent_prompt_trust: 'One-click unsubscribe. Account emails are unaffected.',
  newsletter_consent_prompt_accept: 'Yes, subscribe me',
  newsletter_consent_prompt_decline: 'No, thanks',
  newsletter_consent_prompt_error: 'Your preference could not be saved. Please try again.',
};
